/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDrag } from '@use-gesture/react'
import { useThree } from '@react-three/fiber'
import { Html } from '@react-three/drei'
import { useDispatch, useSelector } from 'react-redux'

import * as actionCreator from '../../../../action/index';
import { const_var, params } from '../../../../redux/reducers/reducer'
import {  wallnameBySec } from '../../../../redux/reducers/building_component/componentReducer'
import useOutsideClick from '../../../../hooks/useOutsideClick';
import { Overlap, TrussOverlap } from '../../../../utils/Overlap';
import { addValidation, getIsEditableCmpOnWall, wallNameArrForValid } from '../../../../utils/Validation'
import { getPosition } from '../../../../utils/GetToolTipPosition'
import { LimitValueOnWall } from '../../../../utils/GetCmpInfoOnWall'

import StandardWindow from './StandardWindow'
import EightGridBlackWindow from './EightGridBlackWindow'
import FourGridBlackWindow from './FourGridBlackWindow'
import WhiteWindow from './WhiteWindow'
import ShutterWindow from './ShutterWindow';
import FauxWindow from './FauxWindow';
import SixGlassesWindow from './SixGlassesWindow';
import WindowEightGridWindow from './WindowEightGridWindow';
import WindowWithoutShuttersWindow from './WindowWithoutShuttersWindow';
import WindowWithShuttersWindow from './WindowWithShuttersWindow';
import WindowWithShuttersFourGridWindow from './WindowWithShuttersFourGridWindow';
import WindowWithShuttersSixGridWindow from './WindowWithShuttersSixGridWindow';
import FrameoutWindow from './FrameoutWindow'
import DoublePaneWindow from './DoublePaneWindow'
import TransomWindow from './TransomWindow'
import TransomSixGridWindow from './TransomSixGridWindow'
import BronzeWindow from './BronzeWindow'
import WindowMeasurements from '../../Measurements/DoorWIndowsMeasurement/WindowMeasurements'
import { extrudeSettings, getWallDirOnCanvas, revertPosOfCmp } from '../../../../utils/Functions'
import WindowOutLineSection from '../OutLineModel/WindowOutLineSection'
import { controls } from '../../../../redux/reducers/common/eventReducer'
import useMouseEvents from '../../../../hooks/useMouseEvents'
import TransomFiveGridBlackWindow from './TransomFiveGridBlackWindow'
import TransomSixGridBlackWindow from './TransomSixGridBlackWindow'
import BlackFrameStandardGlassWindow from './BlackFrameStandardGlassWindow'
import BlackFrameHalfNetWindow from './BlackFrameHalfNetWindow'
import DoublePaneBlackWindow from './DoublePaneBlackWindow'
import { convertToAdjustedFeetInches } from '../../../../redux/reducers/utils'
import { findMaxLimitY } from '../../../../helpers/building/building_config/componentConfig'
import SixGridWindowBlackTrim from './SixGridWindowBlackTrim'
import DoublePaneWhiteWindow from './DoublePaneWhiteWindow'
import NinePanelWindow from './NinePanelWindow'
import StandardWindowWhiteTrim from './StandardWindowWhiteTrim'
import NewBronzeWindow from './NewBronzeWindow'
import SingleVent from './SingleVent'

const WindowModel = ({ 
    id, 
    wallName, 
    compName, 
    compType, 
    width, 
    height, 
    defaultPositionX, 
    defaultPositionY, 
    trimWidth, 
    doorColor,
    overlapTrimColor,
    glassTexture,
    overlapDoorArr = [],
}) => {
    const get = useThree((state) => state.get)
    const dispatch = useDispatch();
    const editRef = useRef();
    // const mainTrussPosInfo = useSelector(state => state.reducer.mainTrussPosInfo)
    // const leanToTrussPosInfo = useSelector(state => state.reducer.leanToTrussPosInfo)
    const isShowEditIconSection = useSelector(state => state.reducer.isShowEditIconSection)
    const selectedCmpType = useSelector(state => state.reducer.selectedCmpType)
    
    const [isAvailablePlace, setIsAvailablePlace] = useState(true)
    const [positionX, setPositionX] = useState(defaultPositionX);
    const [positionY, setPositionY] = useState(defaultPositionY);
    const [startPositionXY, setStartPositionXY] = useState({x: defaultPositionX, y: defaultPositionY});
    const [isDrag, setIsDrag] = useState(false);
    const [isHovered, setIsHovered] = useState(false)
    const [isDelBtnClicked, setIsDelBtnClicked] = useState(false);
    const [isSnackBar, setIsSnackBar] = useState(false);
    const [canClone, setCanClone] = useState(true);
    const [trimColor, setTrimColor] = useState(true);
    const [bindDelta, setBindDelta] = useState([0, 0]);
    // const [ intersect ] = useState(() => new THREE.Vector3());

    const { scene, camera, gl } = useThree();    
    const doorRef = useRef(null);
    const raycaster = new THREE.Raycaster();
    
    const buildingType = wallnameBySec[wallName];
    const targetWallNameArr = wallNameArrForValid.find(subArray => subArray.includes(wallName));
    const sideArray = const_var.newDoorsArray.filter((item) => item.uniqueId !== id && targetWallNameArr.includes(item.userData.wallName));

    const componentDistance = const_var.componentDistance;
    const currentAzimuthalAngle = const_var.controls != undefined && const_var.controls != '' ? const_var.controls.getAzimuthalAngle() : ''; 
    const camAngle = (Math.atan((params.p_d / 2) / (params.p_w / 2)));
    
    const { limitX, limitY, positionZ, rotationY } = LimitValueOnWall("model", compType, wallName, width, height, positionY, isDrag);

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])
    
    const legGroup = new THREE.Group()
    legGroup.name = "legGroup"
    scene.add(legGroup)

    const thickness = 0.3

    const checkDoorTransparent = () => {
        let transparentDoor = false
        let door
        if(const_var.scene != undefined && const_var.scene != "") door = const_var.scene.getObjectByName(`${compName}_${wallName}_${id}_DoorWindows`) 
        if(door != undefined && door.isTransparent != undefined && door.isTransparent == true){
            transparentDoor = true;
            
            if(!params.is_translusant){
                door.traverse((mesh)=>{
                    if(mesh.isMesh){
                        mesh.material.opacity = 0.02
                        mesh.material.transparent = true
                        mesh.material.needsUpdate = true
                    }
                })
            }
        }
        return transparentDoor
    }
    const isDoorTransparent = checkDoorTransparent();
    if(controls.isCheckActiveTab != null && controls.isCheckActiveTab == "doorwindow"){
        setTimeout(() => {
            checkDoorTransparent();
        }, 701);
    }
    
    const onClickDoorComponent = (e) => {
        let isDoorTransparent = checkDoorTransparent();
        setCanClone(true)
        setIsDelBtnClicked(false);

        let isSelect = false;
        
        // if ((const_var.controls !== undefined) && (((controls.isCheckActiveTab === 'doorwindow' || params.is_translusant) ? (!transparentState) : true))) {
            const currentAzimuthalAngle = (const_var.controls!=undefined && const_var.controls != '') ? const_var.controls.getAzimuthalAngle() : 0 ;
            isSelect = getIsEditableCmpOnWall(wallName, currentAzimuthalAngle);
        // }

        if (isSelect && !isDoorTransparent) {
            e.stopPropagation();
            dispatch(actionCreator.setSelectedCmpType('window'))
            dispatch(actionCreator.setIsShowEditIconSection(true));        
            if(params.activeWall != wallName){
                params.activeWall = wallName
            }
            const_var.timer = setTimeout(() => {
                removeFocus()
            },10000)
        }
    }

    const removeFocus = () => {
        if(const_var.showComponentEditBox == false){
            if((document.getElementsByClassName("delete-tooltip") != undefined && document.getElementsByClassName("delete-tooltip")[0]) || (document.getElementsByClassName("warning-tooltip") != undefined && document.getElementsByClassName("warning-tooltip")[0])){
                // console.log("dlete")
            }else{
                dispatch(actionCreator.setSelectedCmpType('none'))
                dispatch(actionCreator.setIsShowEditIconSection(false));
                clearTimeout(const_var.timer);
                setCanClone(true);
            }
            
        }
    }

    const handleDeleteClick = () => {
        if(isDelBtnClicked == true){
            setIsDelBtnClicked(false);
            dispatch(actionCreator.setSelectedCmpType('none'));
            dispatch(actionCreator.setIsShowEditIconSection(false));
            clearTimeout(const_var.timer);
        }
    }

    const handleSetCanClone = () => {
        setCanClone(true);
        dispatch(actionCreator.setSelectedCmpType('none'));
        dispatch(actionCreator.setIsShowEditIconSection(false));
        clearTimeout(const_var.timer);
    }


    const onClickEditButton = (e) => {
        dispatch(actionCreator.handleIconClick(e, id,'door'))
    }

    const cloneComponent = (doorUniqueId, e) => {
        const selectedDoor = const_var.newDoorsArray.filter((item) => item.uniqueId === doorUniqueId);
        const priceData = const_var.entry_points.filter((item) => item.uniqueId === doorUniqueId);

        // implement the clearance free space size
        let parentkey = '';
        let childkey = '';
        let nestedkey = '';
        
        if (selectedDoor.length > 0) {
            parentkey = selectedDoor[0].parent_array_key;
            childkey = selectedDoor[0].child_array_key;
            nestedkey = selectedDoor[0].nested_array_key;
        }
        
        const validationVariable = addValidation({ compType, compName, width, height, wallName, parentkey, childkey, nestedkey });
        const isAdd = validationVariable.isAdd;
        
        setCanClone(isAdd);
        
        // setTimeout(() => {
        //     setCanClone(true);
        // }, 3000);

        if(isAdd){
            setIsSnackBar(!isSnackBar);
            setTimeout(() => {
                setIsSnackBar(false)
            }, 3000);

            if (selectedDoor.length > 0 && priceData.length > 0) {
                let targetObj = {...priceData[0]};
                targetObj.component_wall_name = selectedDoor[0].userData.wallName
                
                dispatch(actionCreator.cloneComponent(doorUniqueId, targetObj))
                dispatch(actionCreator.handleCloseforDoorWindows(e));
            }

        } else{
            setIsSnackBar(false);
        }
    }

    const removeComponent = (doorUniqueId) => {
        setIsDelBtnClicked(false)
        dispatch(actionCreator.removeComponent(doorUniqueId))
    }

    const addedWindowPos = useMemo(() => {
        if (isSnackBar) {
            const addedDoorInfo = const_var.newDoorsArray.find(s => s.uniqueId === const_var.doorUniqueId)
            
            return [addedDoorInfo.positionX - positionX - width, height, 1]
        }
    }, [isSnackBar])

    const occludeState = useMemo(() => {
        let res = false;
        if (const_var.doorUniqueId === id) {
            const direction = getWallDirOnCanvas(wallName);
            if (currentAzimuthalAngle >= -(Math.PI / 2 - camAngle) && currentAzimuthalAngle < (Math.PI / 2 - camAngle)) {
                res = (direction !== 'front');
            } else if (currentAzimuthalAngle >= (Math.PI / 2 - camAngle) && currentAzimuthalAngle < (Math.PI / 2 - camAngle + camAngle * 2)) {
                res = (direction !== 'right');
            } else if (currentAzimuthalAngle >= -((Math.PI / 2 - camAngle) + camAngle * 2) && currentAzimuthalAngle < -(Math.PI / 2 - camAngle)) {
                res = (direction !== 'left');
            } else {
                res = (direction !== 'back');
            }
        }

        return res;
    }, [currentAzimuthalAngle, camAngle, wallName, const_var.doorUniqueId, id]);

    const handleMouseEvent = (e) => {
        if (const_var.callMesure) {
            switch (e.type) {
                case 'pointerover':
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

    useOutsideClick(editRef, (e) => {
        if (!(const_var.showComponentEditBox || const_var.isShowAlert)) setIsDelBtnClicked(false)
        if (const_var.showComponentEditBox || const_var.isShowAlert || !!e.target.innerText) return
        if (const_var.doorUniqueId === id) {
            dispatch(actionCreator.setSelectedCmpType('none'))
            dispatch(actionCreator.setIsShowEditIconSection(false));
        }
    });

    /**********Delete doors and windows when change the wall state********* */
    useMemo(() => {
        if (!isDrag) {
            if (wallName === 'c_b_f_w') {
                if (params.p_f_w !== 'Close') {
                    if (params.cB_addStorage_check_left) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= -params.p_w / 2 + params.cB_addStorage_left) {
                                newArray[currentIndex].userData.wallName = 'c_b_l_s_f_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else if (params.cB_addStorage_check_right) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= params.p_w / 2 - params.cB_addStorage_right) {
                                newArray[currentIndex].userData.wallName = 'c_b_r_s_f_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                     } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                     }
                }
            } else if (wallName === 'c_b_b_w') {
                if (params.p_b_w !== 'Close') {
                    if (params.cB_addStorage_check_left) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= params.p_w / 2 - params.cB_addStorage_left) {
                                newArray[currentIndex].userData.wallName = 'c_b_l_s_b_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else if (params.cB_addStorage_check_right) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= -params.p_w / 2 + params.cB_addStorage_right) {
                                newArray[currentIndex].userData.wallName = 'c_b_r_s_b_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                     } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                     }
                }
            } else if (wallName === 'c_b_r_w') {
                if (params.p_r_w !== 'Close' && compType !== 'window_frameout') {
                    if (params.p_u_c) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= params.p_d / 2 - params.p_u_t) {
                                newArray[currentIndex].userData.wallName = 'c_b_r_s_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'c_b_l_w') {
                if (params.p_l_w !== 'Close' && compType !== 'window_frameout') {
                    if (params.p_u_c) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= -params.p_d / 2 + params.p_u_t) {
                                newArray[currentIndex].userData.wallName = 'c_b_l_s_w';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'c_b_f_s_w') {
                if (params.p_u_c === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_b_s_w') {
                if (params.p_u_c === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_r_s_w') {
                if (params.p_u_c === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.p_u_c === true && params.p_r_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_r_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_l_s_w') {
                if (params.p_u_c === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.p_u_c === true && params.p_l_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_l_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_l_s_r_w') {
                if (params.cB_addStorage_check_left === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_l_s_f_w') {
                if (params.cB_addStorage_check_left === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.cB_addStorage_check_left === true && params.p_f_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_f_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_l_s_b_w') {
                if (params.cB_addStorage_check_left === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.cB_addStorage_check_left === true && params.p_b_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_b_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_r_s_l_w') {
                if (params.cB_addStorage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_r_s_f_w') {
                if (params.cB_addStorage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.cB_addStorage_check_right === true && params.p_f_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_f_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'c_b_r_s_b_w') {
                if (params.cB_addStorage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.cB_addStorage_check_right === true && params.p_b_w === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = 'c_b_b_w';
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'F_L_R_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'F_L_L_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'F_L_F_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_l !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check_front) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front)) {
                                newArray[currentIndex].userData.wallName = 'F_L_F_S_W';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'G_F_L_F_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_F_L_B_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_F_L_L_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_l !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check_front) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            newArray[currentIndex].userData.wallName = 'G_F_L_L_S_W';
                            dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    }
                }
            } else if (wallName === 'G_F_L_R_W') {
                if (params.add_front_lean === false || (params.add_front_lean === true && params.p_b_c_b_f_r !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check_front) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            newArray[currentIndex].userData.wallName = 'G_F_L_R_S_W';
                            dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    }
                }
            } else if (wallName === 'F_L_R_S_W' || wallName === 'F_L_L_S_W' || wallName === 'G_F_L_F_S_W' || wallName === 'G_F_L_B_S_W') {
                if (params.add_storage_check_front === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'F_L_F_S_W' || wallName === 'G_F_L_L_S_W') {
                if (params.add_storage_check_front === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check_front === true && params.p_b_c_b_f_l === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = wallName.replace('S_', '');
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_F_L_R_S_W') {
                if (params.add_storage_check_front === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check_front === true && params.p_b_c_b_f_r === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = wallName.replace('S_', '');
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'B_L_F_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'B_L_B_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'B_L_S_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_l !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check_back) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= -params.leanB_p_pos + params.leanB_p_d / 2 - parseInt(params.add_storage_back)) {
                                newArray[currentIndex].userData.wallName = 'B_L_F_S_W';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'G_B_L_F_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_B_L_B_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_B_L_L_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_l !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check_back) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            newArray[currentIndex].userData.wallName = 'G_B_L_L_S_W';
                            dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    }
                }
            } else if (wallName === 'G_B_L_R_W') {
                if (params.add_back_lean === false || (params.add_back_lean === true && params.p_b_c_b_b_r !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check_back) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            newArray[currentIndex].userData.wallName = 'G_B_L_R_S_W';
                            dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    }
                }
            } else if (wallName === 'B_L_L_S_W' || wallName === 'B_L_R_S_W' || wallName === 'G_B_L_F_S_W' || wallName === 'G_B_L_B_S_W') {
                if (params.add_storage_check_back === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'B_L_F_S_W' || wallName === 'G_B_L_L_S_W') {
                if (params.add_storage_check_back === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check_back === true && params.p_b_c_b_b_l === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        if (wallName === 'B_L_F_S_W') {
                            newArray[currentIndex].userData.wallName = 'B_L_S_W';
                        } else {
                            newArray[currentIndex].userData.wallName = wallName.replace('S_', '');
                        }
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_B_L_R_S_W') {
                if (params.add_storage_check_back === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check_back === true && params.p_b_c_b_b_r === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        if (wallName === 'B_L_F_S_W') {
                            newArray[currentIndex].userData.wallName = 'B_L_S_W';
                        } else {
                            newArray[currentIndex].userData.wallName = wallName.replace('S_', '');
                        }
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_F_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_B_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_R_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check_right) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX - newArray[currentIndex].width / 2 - componentDistance >= -params.leanR_p_pos + params.leanR_p_d / 2 - parseInt(params.add_storage_right)) {
                                newArray[currentIndex].userData.wallName = 'R_L_R_S_W';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'G_R_L_F_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_R_L_B_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_R_L_L_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check_right) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            newArray[currentIndex].userData.wallName = 'G_R_L_L_S_W';
                            dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    }
                }
            } else if (wallName === 'G_R_L_R_W') {
                if (params.add_right_lean === false || (params.add_right_lean === true && params.p_b_c_b_r_r !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check_right) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            newArray[currentIndex].userData.wallName = 'G_R_L_R_S_W';
                            dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    }
                }
            } else if (wallName === 'R_L_F_S_W' || wallName === 'R_L_B_S_W' || wallName === 'G_R_L_F_S_W' || wallName === 'G_R_L_B_S_W') {
                if (params.add_storage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_R_S_W' || wallName === 'G_R_L_L_S_W') {
                if (params.add_storage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check_right === true && params.p_b_c_b_r === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = wallName.replace('S_', '');
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_R_L_R_S_W') {
                if (params.add_storage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check_right === true && params.p_b_c_b_r_r === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = wallName.replace('S_', '');
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'R_L_L_S_W') {
                if (params.add_storage_check_right === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'L_L_F_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'L_L_B_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'L_L_L_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            if (newArray[currentIndex].positionX + newArray[currentIndex].width / 2 + componentDistance <= params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage)) {
                                newArray[currentIndex].userData.wallName = 'L_L_L_S_W';
                                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                            } else {
                                const updateNewArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                                setIsAvailablePlace(false);
                                dispatch(actionCreator.updateDoorWindowsArray(updateNewArray,true));
                            }
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                    }
                }
            } else if (wallName === 'G_L_L_F_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l_f !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_L_L_B_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l_b !== 'Close')) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_L_L_L_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            newArray[currentIndex].userData.wallName = 'G_L_L_L_S_W';
                            dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    }
                }
            } else if (wallName === 'G_L_L_R_W') {
                if (params.add_left_lean === false || (params.add_left_lean === true && params.p_b_c_b_l_r !== 'Close' && compType !== 'window_frameout')) {
                    if (params.add_storage_check) {
                        const newArray = [...const_var.newDoorsArray];
                        const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                        if (currentIndex !== -1) {
                            newArray[currentIndex].userData.wallName = 'G_L_L_R_S_W';
                            dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                        }
                    } else {
                        const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                        setIsAvailablePlace(false);
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    }
                }
            } else if (wallName === 'L_L_F_S_W' || wallName === 'L_L_B_S_W' || wallName === 'L_L_R_S_W' || wallName === 'G_L_L_F_S_W' || wallName === 'G_L_L_B_S_W') {
                if (params.add_storage_check === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'L_L_L_S_W' || wallName === 'G_L_L_L_S_W') {
                if (params.add_storage_check === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check === true && params.p_b_c_b_l === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = wallName.replace('S_', '');
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            } else if (wallName === 'G_L_L_R_S_W') {
                if (params.add_storage_check === false) {
                    const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);
                    setIsAvailablePlace(false);
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                } else if (params.add_storage_check === true && params.p_b_c_b_l_r === 'Close') {
                    const newArray = [...const_var.newDoorsArray];
                    const currentIndex = newArray.findIndex((item) => item.uniqueId === id);
                    if (currentIndex !== -1) {
                        newArray[currentIndex].userData.wallName = wallName.replace('S_', '');
                    }
                    dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                }
            }
        }
    
    }, [wallName, params.p_f_w, params.p_b_w, params.p_r_w, params.p_l_w, params.p_u_c, params.cB_addStorage_check_left, params.cB_addStorage_check_right, params.add_front_lean, params.p_b_c_b_f_f, params.p_b_c_b_f_b, params.p_b_c_b_f_l, params.add_storage_check_front, params.add_back_lean, params.p_b_c_b_b_f, params.p_b_c_b_b_b, params.p_b_c_b_b_l, params.add_storage_check_back, params.add_right_lean, params.p_b_c_b_r_f, params.p_b_c_b_r_b, params.p_b_c_b_r, params.add_storage_check_right, params.add_left_lean, params.p_b_c_b_l_f, params.p_b_c_b_l_b, params.p_b_c_b_l, params.add_storage_check, params.p_b_c_b_l_r, params.p_b_c_b_r_r, params.p_b_c_b_f_r, params.p_b_c_b_b_r])
    
    /**********Delete doors and windows when change the wall size********* */
    useEffect(() => {
        if (!isDrag) {
            let maxLimitObj = findMaxLimitY(buildingType, wallName, height, width, componentDistance,defaultPositionX, limitY.max)
            if (defaultPositionX < limitX.min || defaultPositionX > limitX.max || defaultPositionY < limitY.min || defaultPositionY > limitY.max ||  defaultPositionY >  maxLimitObj?.maxLimit) {
                const currentCompObj = const_var.newDoorsArray.find(item => item.uniqueId === id);
                const newArray = const_var.newDoorsArray.filter(item => item.uniqueId !== id);

                setIsAvailablePlace(false);
                dispatch(actionCreator.updateDoorWindowsArray(newArray,true));
                
                if (const_var.isFromCompare) {
                    dispatch(actionCreator.addDoorComponent(compType, compName, wallName, currentCompObj.size, currentCompObj.parent_array_key, currentCompObj.child_array_key, currentCompObj.nested_array_key, currentCompObj))
                }
            }
        }
    }, [
        defaultPositionX, defaultPositionY,
        compType, wallName, width, height, positionY, isDrag, 
        params.p_w, params.p_d, params.p_h, params.p_r_p, params.singleSlope, 

        params.p_u_t, params.cB_addStorage_left, params.cB_addStorage_right,
        params.add_storage_front, params.add_storage_back, params.add_storage, params.add_storage_right, 
        params.frontLeanStoragePosition, params.endStoragePositionZ, params.backLeanStoragePosition, params.leftLeanStoragePosition, params.rightLeanStoragePosition,

        params.add_right_front_lean_porch, params.add_right_back_lean_porch,
        
        params.leanF_p_w, params.leanF_p_d, params.leanF_p_h, params.leanF_p_pos, params.b_l_t_r_pF, 
        params.leanB_p_w, params.leanB_p_d, params.leanB_p_h, params.leanB_p_pos, params.b_l_t_r_pB, 
        params.lean_p_w,  params.lean_p_d,  params.lean_p_h,  params.lean_p_pos,  params.b_l_t_r_p, 
        params.leanR_p_w, params.leanR_p_d, params.leanR_p_h, params.leanR_p_pos, params.b_l_t_r_pR, 
    ]);
    
    useEffect(() => {
        if (selectedCmpType === 'window' && isShowEditIconSection && const_var.doorUniqueId === id) {
            if (editRef.current) editRef.current.parentElement.parentElement.style.zIndex = 1;
        }
    }, [editRef.current, isShowEditIconSection, const_var.isShowAlert, const_var.showComponentEditBox ])

    useMemo(() => {
        setPositionX(defaultPositionX);
        setPositionY(defaultPositionY);
        setStartPositionXY({x: defaultPositionX, y: defaultPositionY});
    }, [defaultPositionX, defaultPositionY])

    const [delPosition, setDelPosition] = useState('right');
    const setDelTooltipPosition = (e) => {
        const tooltipSize = window.innerWidth > 992 ? [285, 211] : [215, 172];
        setDelPosition(getPosition(e, tooltipSize));
    }

    const [warnPosition, setWarnPosition] = useState('right');
    const setWarnTooltipPosition = (e) => {
        const tooltipSize = window.innerWidth > 992 ? [285, 74] : [215, 95];
        setWarnPosition(getPosition(e, tooltipSize));
    }

    useEffect(() => {
        if( (wallName === 'c_b_r_w' && params.p_r_w === 'Open' && !params.p_c_p_r) || 
            (wallName === 'c_b_l_w' && params.p_l_w === 'Open' && !params.p_c_p_l) ||
            (wallName === 'F_L_F_W' && params.p_b_c_b_f_l === 'Open') ||
            (wallName === 'B_L_S_W' && params.p_b_c_b_b_l === 'Open') ||
            (wallName === 'R_L_R_W' && params.p_b_c_b_r === 'Open') ||
            (wallName === 'L_L_L_W' && params.p_b_c_b_l === 'Open') ||
            (wallName === 'G_F_L_L_W' && params.p_b_c_b_f_l === 'Open') ||
            (wallName === 'G_F_L_R_W' && params.p_b_c_b_f_r === 'Open') ||
            (wallName === 'G_B_L_L_W' && params.p_b_c_b_b_l === 'Open') ||
            (wallName === 'G_B_L_R_W' && params.p_b_c_b_b_r === 'Open') ||
            (wallName === 'G_L_L_L_W' && params.p_b_c_b_l === 'Open') ||
            (wallName === 'G_L_L_R_W' && params.p_b_c_b_l_r === 'Open') ||
            (wallName === 'G_R_L_L_W' && params.p_b_c_b_r === 'Open') ||
            (wallName === 'G_R_L_R_W' && params.p_b_c_b_r_r === 'Open')
        ) setTrimColor('#C8C8C8')
        else setTrimColor(params.p_t_c.replace('0x', '#'))
    }, [wallName, params.p_r_w, params.p_l_w, params.p_b_c_b_f_l, params.p_b_c_b_b_l, params.p_b_c_b_r, params.p_b_c_b_l, params.p_t_c, params.p_c_p_l ])


    // const trussModelPosInfoArr = useMemo(() => {
    //     let count, distance = 0;
        
    //     const initDistance = legDistance;
    //     const tempCount = Math.floor(params.p_d * 3 / initDistance);
    //     if (params.p_d * 3 === tempCount * initDistance) {
    //         count = tempCount;
    //         distance = initDistance;
    //     } else if (params.p_d * 3 - tempCount * initDistance < initDistance / 2) {
    //         count = tempCount;
    //         distance = params.p_d * 3 / count;
    //     } else {
    //         count = tempCount + 1;
    //         distance = params.p_d * 3 / count;
    //     }
        
    //     const posInfoArr = Array.from({ length: count + 1 }, (_, index) => distance * index - params.p_d * 3 / 2)

    //     return posInfoArr
    // }, [params.p_d, legDistance, params.trussType])
  

    let count, distance1;
    const initDistance = legDistance;
    const tempAvailableSize = params.lean_p_w - 0.22;
    const tempCount = Math.floor(tempAvailableSize / initDistance);

    if (tempAvailableSize === tempCount * initDistance) {
        count = tempCount;
        distance1 = initDistance;
    } else if (tempAvailableSize - tempCount * initDistance < initDistance / 2) {
        count = tempCount;
        distance1 = tempAvailableSize / count;
    } else {
        count = tempCount + 1;
        distance1 = tempAvailableSize / count;
    }

    const handleMouseDown = (e, type) => {
    if(type == "window"){
        let event = e
        let isDraggable = false;
        let isDoorTransparent = checkDoorTransparent();
        let currentComponent = e.eventObject
        let trim1
        let trim2
        let trim1Color = params.p_t_c.replace("#","0x");
        let trim2Color = params.p_t_c.replace("#","0x");
        let mesh2
        let newDoorsArray = JSON.parse(JSON.stringify(const_var.newDoorsArray))
        let doorArr = newDoorsArray.filter((data)=> {
            const data_temp_wallName = data.userData.wallName.at(-3) === 'S' ? data.userData.wallName.slice(0,-3) : data.userData.wallName.slice(0,-1);
            const doorRef_temp_wallName = doorRef.current.userData.wallName.at(-3) === 'S' ? doorRef.current.userData.wallName.slice(0,-3) : doorRef.current.userData.wallName.slice(0,-1);
            return (data_temp_wallName == doorRef_temp_wallName && data.name != doorRef.current.userData.name);
        });
        

        if ((const_var.controls !== undefined) && (((controls.isCheckActiveTab === 'doorwindow' || params.is_translusant) ? (!isDoorTransparent) : true))) {
            const currentAzimuthalAngle = (const_var.controls!=undefined && const_var.controls != '') ? const_var.controls.getAzimuthalAngle() : 0 ;
            isDraggable = getIsEditableCmpOnWall(wallName, currentAzimuthalAngle);
        }
        
        if(isDraggable && doorRef.current != undefined){
            const_var.controls.enableRotate = false;
            get().gl.domElement.style.cursor = 'move';
            const_var.controls.update();

            e.stopPropagation();
            const_var.doorUniqueId = id
            setIsDrag(true)
            // setCurrentComponent(e.eventObject)

            setStartPositionXY({ x: positionX, y: positionY });

            let intersectWall = scene.getObjectByName("intersectWall")
            let intersectLeg = scene.getObjectByName("intersectLeg")
            if(intersectWall != undefined){
                scene.remove(intersectWall)
                scene.remove(intersectLeg)
            }

            let adjustedX;
            let adjustedZ;
            if (rotationY === 0) {
                adjustedX = 0;
                adjustedZ = doorRef.current.position.z;
            } else if (rotationY === Math.PI) {
                adjustedX = 0;
                adjustedZ = -doorRef.current.position.z;
            } else if (rotationY === -Math.PI / 2) {
                adjustedX = -doorRef.current.position.z;
                adjustedZ = 0;
            } else if (rotationY === Math.PI / 2) {
                adjustedX = doorRef.current.position.z;
                adjustedZ = 0;
            }

            const model = new THREE.Shape();
            model.moveTo(-1000 - width / 2 - componentDistance, 0 );
            model.lineTo(1000 + width / 2 + componentDistance, 0);
            model.lineTo(1000 + width / 2 + componentDistance, params.p_h+((params.p_r_p/12)*params.p_w));
            model.lineTo(-1000 - width / 2 - componentDistance, params.p_h+((params.p_r_p/12)*params.p_w) );
            model.closePath();
            
            intersectWall = new THREE.Mesh(new THREE.ExtrudeGeometry(model, extrudeSettings(0.5)))
            intersectWall.position.set(adjustedX,0,adjustedZ)
            intersectWall.rotateY(rotationY)
            intersectWall.name = "intersectWall"
            intersectWall.visible = false
            scene.add(intersectWall)            

            // Code start to highlight the legs which is intersecting the window
            if(doorRef.current.userData.section != undefined && 
                (
                    (doorRef.current.userData.section == "center" && (rotationY === -Math.PI / 2 || rotationY === Math.PI / 2)) || 
                    (doorRef.current.userData.section == "leftlean" && rotationY === -Math.PI / 2) ||
                    (doorRef.current.userData.section == "rightlean" && rotationY === Math.PI / 2) ||
                    (doorRef.current.userData.section == "frontlean" && rotationY === 0) ||
                    (doorRef.current.userData.section == "backlean" && rotationY === Math.PI) ||
                    (doorRef.current.userData.section == "gableLeftLean" && (rotationY === Math.PI || rotationY === 0)) ||
                    (doorRef.current.userData.section == "gableRightLean" && (rotationY === Math.PI || rotationY === 0)) ||
                    (doorRef.current.userData.section == "gableFrontLean" && (rotationY === Math.PI / 2 || rotationY === -Math.PI / 2)) ||
                    (doorRef.current.userData.section == "gableBackLean" && (rotationY === Math.PI / 2 || rotationY === -Math.PI / 2))
                )
            ){
                let legPosArr = []
                let key = doorRef.current.userData.section;
                if (doorRef.current.userData.section === 'center') {
                    legPosArr = const_var.leanToLegPosObj[key].filter((leg)=>doorRef.current.position.x - (width/2) <= leg && doorRef.current.position.x + (width/2) >= leg)
                } else if (doorRef.current.userData.section.includes("gable")) {
                    legPosArr = const_var.leanToLegPosObj[key].filter((leg)=>Math.abs(doorRef.current.position.x) - (width/2) <= Math.abs(leg) && Math.abs(doorRef.current.position.x) + (width/2) >= Math.abs(leg))
                    if (doorRef.current.userData.section.includes("Right")) {
                        if (doorRef.current.position.x < 0) legPosArr = legPosArr.map(item => -item)
                    } else {
                        if (doorRef.current.position.x > 0) legPosArr = legPosArr.map(item => -item)
                    }
                } else {
                    key = key.replace("lean", "")
                    legPosArr = const_var.leanToLegPosObj[key].filter((leg)=>doorRef.current.position.x - (width/2) <= leg && doorRef.current.position.x + (width/2) >= leg)
                }

                const legModel = new THREE.Shape();
                
                if(doorRef.current.userData.section == "center"){
                    legModel.moveTo(params.p_w / 2, 0 );
                    legModel.lineTo(params.p_w / 2, params.p_h);
                    if(params.singleSlope){
                        legModel.lineTo(-params.p_w / 2, params.p_h - ((params.p_r_p/12)*(params.p_w)));
                    }else{
                        if (params.p_r_s === 1) {
                            legModel.lineTo(params.p_w / 2, params.p_h + const_var.roofRegularDst);
                            legModel.quadraticCurveTo(
                                params.p_w / 2, params.p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.p_r_p / 12 / 10,
                                params.p_w / 2 - const_var.roofRegularDst, params.p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12
                            );
                            legModel.lineTo(0, params.p_h + params.p_r_p / 12 * params.p_w / 2 + const_var.roofRegularDst * 2);
                            legModel.lineTo(-params.p_w / 2 + const_var.roofRegularDst, params.p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
                            legModel.quadraticCurveTo(
                                -params.p_w / 2, params.p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.p_r_p / 12 / 10,
                                -params.p_w / 2, params.p_h + const_var.roofRegularDst
                            );
                            legModel.lineTo(-params.p_w / 2, params.p_h);
                        } else {
                            legModel.lineTo(0, params.p_h + ((params.p_r_p/12)*(params.p_w/2)));
                            legModel.lineTo(-params.p_w / 2, params.p_h);
                        }
                    }
                    legModel.lineTo(-params.p_w / 2, 0 );
                    legModel.lineTo(-params.p_w / 2 + thickness, 0 );
                    if(params.singleSlope){
                        legModel.lineTo(-params.p_w / 2 + thickness, params.p_h - ((params.p_r_p/12)*(params.p_w)) - thickness);
                    }else{
                        if (params.p_r_s === 1) {
                            legModel.lineTo(-params.p_w / 2 + thickness, params.p_h - thickness)
                            legModel.lineTo(-params.p_w / 2 + thickness, params.p_h - thickness + const_var.roofRegularDst)
                            legModel.quadraticCurveTo(
                                -params.p_w / 2 + thickness, params.p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.p_r_p / 12 / 10,
                                -params.p_w / 2 + thickness + const_var.roofRegularDst, params.p_h - thickness + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
                            legModel.lineTo(0, params.p_h + params.p_r_p / 12 * params.p_w / 2 + const_var.roofRegularDst * 2 - thickness);
                            legModel.lineTo(params.p_w / 2 - thickness - const_var.roofRegularDst, params.p_h - thickness + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12)
                            legModel.quadraticCurveTo(
                                params.p_w / 2 - thickness, params.p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.p_r_p / 12 / 10,
                                params.p_w / 2 - thickness, params.p_h - thickness + const_var.roofRegularDst);
                        } else {
                            legModel.lineTo(-params.p_w / 2 + thickness, params.p_h - thickness);
                            legModel.lineTo(0, params.p_h + ((params.p_r_p/12)*(params.p_w/2)) - thickness);
                        }
                    }
                    legModel.lineTo(params.p_w / 2 - thickness, params.p_h - thickness);
                    legModel.lineTo(params.p_w / 2 - thickness, 0 );
                }else if(doorRef.current.userData.section == "leftlean"){
                    legModel.moveTo(-params.p_w / 2 - params.lean_p_w, 0 );
                    legModel.lineTo(-params.p_w / 2 - params.lean_p_w, params.lean_p_h);
                    if (params.p_r_s === 1) {
                        legModel.lineTo(-params.p_w / 2 - params.lean_p_w, params.lean_p_h + const_var.roofRegularDst);
                        legModel.quadraticCurveTo(
                            -params.p_w / 2 - params.lean_p_w, params.lean_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_p / 12 / 10,
                            -params.p_w / 2 - params.lean_p_w + const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12
                        )
                        legModel.lineTo(-params.p_w / 2, params.lean_p_h + params.b_l_t_r_p / 12 * params.lean_p_w + const_var.roofRegularDst * 2);
                        legModel.lineTo(-params.p_w / 2, params.lean_p_h + params.b_l_t_r_p / 12 * params.lean_p_w + const_var.roofRegularDst * 2 - thickness);
                        legModel.lineTo(-params.p_w / 2 - params.lean_p_w + const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12 - thickness);
                        legModel.quadraticCurveTo(
                            -params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_p / 12 / 10,
                            -params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h + const_var.roofRegularDst
                        )
                    } else {
                        legModel.lineTo(-params.p_w / 2, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w)));
                        legModel.lineTo(-params.p_w / 2, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w)) - thickness);
                    }
                    legModel.lineTo(-params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h  - thickness);
                    legModel.lineTo(-params.p_w / 2 - params.lean_p_w + thickness, 0 );
                    legModel.lineTo(-params.p_w / 2 - params.lean_p_w + thickness, 0 );
                }else if(doorRef.current.userData.section == "rightlean"){
                    legModel.moveTo(params.p_w / 2 + params.leanR_p_w, 0 );
                    legModel.lineTo(params.p_w / 2 + params.leanR_p_w, params.leanR_p_h);
                    if (params.p_r_s === 1) {
                        legModel.lineTo(params.p_w / 2 + params.leanR_p_w, params.leanR_p_h + const_var.roofRegularDst);
                        legModel.quadraticCurveTo(
                            params.p_w / 2 + params.leanR_p_w, params.leanR_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pR / 12 / 10,
                            params.p_w / 2 + params.leanR_p_w - const_var.roofRegularDst, params.leanR_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pR / 12
                        )
                        legModel.lineTo(params.p_w / 2, params.leanR_p_h + params.b_l_t_r_pR / 12 * params.leanR_p_w + const_var.roofRegularDst * 2);
                        legModel.lineTo(params.p_w / 2, params.leanR_p_h + params.b_l_t_r_pR / 12 * params.leanR_p_w + const_var.roofRegularDst * 2 -thickness);
                        legModel.lineTo(params.p_w / 2 + params.leanR_p_w - const_var.roofRegularDst, params.leanR_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pR / 12 - thickness);
                        legModel.quadraticCurveTo(
                            params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pR / 12 / 10,
                            params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h + const_var.roofRegularDst
                        )
                    }else {
                        legModel.lineTo(params.p_w / 2, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)));
                        legModel.lineTo(params.p_w / 2, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - thickness);
                    }
                    legModel.lineTo(params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h  - thickness);
                    legModel.lineTo(params.p_w / 2 + params.leanR_p_w - thickness, 0 );
                }else if(doorRef.current.userData.section == "frontlean"){
                    legModel.moveTo(params.p_d / 2 + params.leanF_p_w, 0 );
                    legModel.lineTo(params.p_d / 2 + params.leanF_p_w, params.leanF_p_h);
                    if (params.p_r_s === 1) {
                        legModel.lineTo(params.p_d / 2 + params.leanF_p_w, params.leanF_p_h + const_var.roofRegularDst);
                        legModel.quadraticCurveTo(
                            params.p_d / 2 + params.leanF_p_w, params.leanF_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pF / 12 / 10,
                            params.p_d / 2 + params.leanF_p_w - const_var.roofRegularDst, params.leanF_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12
                        )
                        legModel.lineTo(params.p_d / 2, params.leanF_p_h + params.b_l_t_r_pF / 12 * params.leanF_p_w + const_var.roofRegularDst * 2);
                        legModel.lineTo(params.p_d / 2, params.leanF_p_h + params.b_l_t_r_pF / 12 * params.leanF_p_w + const_var.roofRegularDst * 2 -thickness);
                        legModel.lineTo(params.p_d / 2 + params.leanF_p_w - const_var.roofRegularDst, params.leanF_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12 - thickness);
                        legModel.quadraticCurveTo(
                            params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pF / 12 / 10,
                            params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h + const_var.roofRegularDst
                        )
                    }else {
                        legModel.lineTo(params.p_d / 2, params.leanF_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)));
                        legModel.lineTo(params.p_d / 2, params.leanF_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - thickness);
                    }
                    legModel.lineTo(params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h  - thickness);
                    legModel.lineTo(params.p_d / 2 + params.leanF_p_w - thickness, 0 );
                }else if(doorRef.current.userData.section == "backlean"){
                    legModel.moveTo(-params.p_d / 2 - params.leanB_p_w, 0 );
                    legModel.lineTo(-params.p_d / 2 - params.leanB_p_w, params.leanB_p_h);
                    if (params.p_r_s === 1) {
                        legModel.lineTo(-params.p_d / 2 - params.leanB_p_w, params.leanB_p_h + const_var.roofRegularDst);
                        legModel.quadraticCurveTo(
                            -params.p_d / 2 - params.leanB_p_w, params.leanB_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pB / 12 / 10,
                            -params.p_d / 2 - params.leanB_p_w + const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12
                        )
                        legModel.lineTo(-params.p_d / 2, params.leanB_p_h + params.b_l_t_r_pB / 12 * params.leanB_p_w + const_var.roofRegularDst * 2);
                        legModel.lineTo(-params.p_d / 2, params.leanB_p_h + params.b_l_t_r_pB / 12 * params.leanB_p_w + const_var.roofRegularDst * 2 - thickness);
                        legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12 - thickness);
                        legModel.quadraticCurveTo(
                            -params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pB / 12 / 10,
                            -params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h + const_var.roofRegularDst
                        )
                    } else {
                        legModel.lineTo(-params.p_d / 2, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w)));
                        legModel.lineTo(-params.p_d / 2, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w)) - thickness);
                    }
                    legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h  - thickness);
                    legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + thickness, 0 );
                } else if(doorRef.current.userData.section == "gableLeftLean") {
                    legModel.moveTo(0 - params.lean_p_w / 2, 0 );
                    legModel.lineTo(0 - params.lean_p_w / 2, params.lean_p_h);
                    legModel.lineTo(0, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w / 2)));
                    legModel.lineTo(0 + params.lean_p_w / 2, params.lean_p_h);
                    legModel.lineTo(0 + params.lean_p_w / 2, 0 );
                    legModel.lineTo(0 + params.lean_p_w / 2 - thickness, 0 );
                    legModel.lineTo(0 + params.lean_p_w / 2 - thickness, params.lean_p_h - thickness);
                    legModel.lineTo(0, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w / 2)) - thickness);
                    legModel.lineTo(0 - params.lean_p_w / 2 + thickness, params.lean_p_h  - thickness);
                    legModel.lineTo(0 - params.lean_p_w / 2 + thickness, 0 );
                } else if(doorRef.current.userData.section == "gableRightLean") {
                    legModel.moveTo(0 - params.leanR_p_w / 2, 0 );
                    legModel.lineTo(0 - params.leanR_p_w / 2, params.leanR_p_h);
                    legModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w / 2)));
                    legModel.lineTo(0 + params.leanR_p_w / 2, params.leanR_p_h);
                    legModel.lineTo(0 + params.leanR_p_w / 2, 0 );
                    legModel.lineTo(0 + params.leanR_p_w / 2 - thickness, 0 );
                    legModel.lineTo(0 + params.leanR_p_w / 2 - thickness, params.leanR_p_h - thickness);
                    legModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w / 2)) - thickness);
                    legModel.lineTo(0 - params.leanR_p_w / 2 + thickness, params.leanR_p_h  - thickness);
                    legModel.lineTo(0 - params.leanR_p_w / 2 + thickness, 0 );
                } else if(doorRef.current.userData.section == "gableFrontLean") {
                    legModel.moveTo(0 - params.leanF_p_w / 2, 0 );
                    legModel.lineTo(0 - params.leanF_p_w / 2, params.leanF_p_h);
                    legModel.lineTo(0, params.leanF_p_h + ((params.b_l_t_r_pF/12)*(params.leanF_p_w / 2)));
                    legModel.lineTo(0 + params.leanF_p_w / 2, params.leanF_p_h);
                    legModel.lineTo(0 + params.leanF_p_w / 2, 0 );
                    legModel.lineTo(0 + params.leanF_p_w / 2 - thickness, 0 );
                    legModel.lineTo(0 + params.leanF_p_w / 2 - thickness, params.leanF_p_h - thickness);
                    legModel.lineTo(0, params.leanF_p_h + ((params.b_l_t_r_pF/12)*(params.leanF_p_w / 2)) - thickness);
                    legModel.lineTo(0 - params.leanF_p_w / 2 + thickness, params.leanF_p_h  - thickness);
                    legModel.lineTo(0 - params.leanF_p_w / 2 + thickness, 0 );
                } else if(doorRef.current.userData.section == "gableBackLean") {
                    legModel.moveTo(0 - params.leanB_p_w / 2, 0 );
                    legModel.lineTo(0 - params.leanB_p_w / 2, params.leanB_p_h);
                    legModel.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w / 2)));
                    legModel.lineTo(0 + params.leanB_p_w / 2, params.leanB_p_h);
                    legModel.lineTo(0 + params.leanB_p_w / 2, 0 );
                    legModel.lineTo(0 + params.leanB_p_w / 2 - thickness, 0 );
                    legModel.lineTo(0 + params.leanB_p_w / 2 - thickness, params.leanB_p_h - thickness);
                    legModel.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w / 2)) - thickness);
                    legModel.lineTo(0 - params.leanB_p_w / 2 + thickness, params.leanB_p_h  - thickness);
                    legModel.lineTo(0 - params.leanB_p_w / 2 + thickness, 0 );
                }
                legModel.closePath();

                intersectLeg = new THREE.Mesh(new THREE.ExtrudeGeometry(legModel, extrudeSettings(0.3)))
                intersectLeg.updateMatrix()
                intersectLeg.name = "intersectLeg"
                intersectLeg.visible = false
                intersectLeg.material.color.setHex("0x900000")
                intersectLeg.material.depthTest = false
                intersectLeg.material.transparent = false
                intersectLeg.material.needsUpdate = true
                scene.add(intersectLeg)


                legPosArr.map((legPos)=>{

                    let newArr = {}
                    if(doorRef.current.userData.section == "center"){
                        let key = doorRef.current.userData.section.replace("lean", "");
                        if(const_var.leanToLegPosObj[key] != undefined){
                            let closest = const_var.leanToLegPosObj[key].reduce((a, b) => {
                                return Math.abs(b - (params.p_d/2)) < Math.abs(a - (params.p_d/2)) ? b : a;
                            });
                            let lengthIndex = const_var.leanToLegPosObj[key]?.findIndex((num) => num >= closest)
                            if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean"){
                                let closest = const_var.leanToLegPosObj[key].reduce((a, b) => {
                                    return Math.abs(b - (params.p_w/2)) < Math.abs(a - (params.p_w/2)) ? b : a;
                                });
                                lengthIndex = const_var.leanToLegPosObj[key]?.findIndex((num) => num == closest)
                            }
                            
                            let j = 1
                            for (let i = lengthIndex+1; i <=  const_var.leanToLegPosObj[key].length-1; i++) {  
                                newArr[const_var.leanToLegPosObj[key][i]] = distance1*j
                                j++
                            }
                            Object.entries(newArr).map((val)=>{
                                newArr[-val[0]] = val[1]
                            })
                        }
                    }
                    
                    if(Object.keys(newArr).length > 0){
                    let positionX = 0
                    let positionZ = legPos - (thickness/2)
                    let leanDimension = params.lean_p_d
                    let checkPos = positionZ
                    let rotation_y = 0;
                    const legModel = new THREE.Shape();
                    if (doorRef.current.userData.section == "center" && rotationY === -Math.PI / 2){
                        positionZ = legPos - (thickness/2)
                    }else if(doorRef.current.userData.section == "center" && rotationY === Math.PI / 2){
                        positionZ = -legPos - (thickness/2)
                    }else if(doorRef.current.userData.section == "leftlean" && rotationY === -Math.PI / 2){
                        positionZ = legPos - (thickness/2)
                        leanDimension = params.lean_p_d
                        checkPos = positionZ

                        legModel.moveTo(-params.p_w / 2 - params.lean_p_w, 0 );
                        legModel.lineTo(-params.p_w / 2 - params.lean_p_w, params.lean_p_h);
                        if (params.p_r_s === 1) {
                            legModel.lineTo(-params.p_w / 2 - params.lean_p_w, params.lean_p_h + const_var.roofRegularDst);
                            legModel.quadraticCurveTo(
                                -params.p_w / 2 - params.lean_p_w, params.lean_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_p / 12 / 10,
                                -params.p_w / 2 - params.lean_p_w + const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12
                            )
                            legModel.lineTo(-params.p_w / 2 - newArr[legPos], params.lean_p_h + params.b_l_t_r_p / 12 * params.lean_p_w + const_var.roofRegularDst * 2 - newArr[legPos] * params.b_l_t_r_p / 12);
                            legModel.lineTo(-params.p_w / 2 - newArr[legPos], params.lean_p_h + params.b_l_t_r_p / 12 * params.lean_p_w + const_var.roofRegularDst * 2 - newArr[legPos] * params.b_l_t_r_p / 12 - thickness);
                            legModel.lineTo(-params.p_w / 2 - params.lean_p_w + const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12 - thickness);
                            legModel.quadraticCurveTo(
                                -params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_p / 12 / 10,
                                -params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h + const_var.roofRegularDst
                            )
                        } else {
                            legModel.lineTo(-params.p_w / 2 - newArr[legPos], params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w)) - newArr[legPos] * params.b_l_t_r_p / 12);
                            legModel.lineTo(-params.p_w / 2 - newArr[legPos], params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w)) - newArr[legPos] * params.b_l_t_r_p / 12 - thickness);
                        }
                        legModel.lineTo(-params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h  - thickness);
                        legModel.lineTo(-params.p_w / 2 - params.lean_p_w + thickness, 0 );
                    }else if(doorRef.current.userData.section == "rightlean" && rotationY === Math.PI / 2){
                        positionZ = -legPos - (thickness/2)
                        leanDimension = params.leanR_p_d
                        checkPos = positionZ

                        legModel.moveTo(params.p_w / 2 + params.leanR_p_w, 0 );
                        legModel.lineTo(params.p_w / 2 + params.leanR_p_w, params.leanR_p_h);
                        if (params.p_r_s === 1) {
                            legModel.lineTo(params.p_w / 2 + params.leanR_p_w, params.leanR_p_h + const_var.roofRegularDst);
                            legModel.quadraticCurveTo(
                                params.p_w / 2 + params.leanR_p_w, params.leanR_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pR / 12 / 10,
                                params.p_w / 2 + params.leanR_p_w - const_var.roofRegularDst, params.leanR_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pR / 12
                            )
                            legModel.lineTo(params.p_w / 2 + newArr[legPos], params.leanR_p_h + params.b_l_t_r_pR / 12 * params.leanR_p_w + const_var.roofRegularDst * 2 - newArr[legPos] * params.b_l_t_r_p / 12);
                            legModel.lineTo(params.p_w / 2 + newArr[legPos], params.leanR_p_h + params.b_l_t_r_pR / 12 * params.leanR_p_w + const_var.roofRegularDst * 2 - newArr[legPos] * params.b_l_t_r_p / 12 -thickness);
                            legModel.lineTo(params.p_w / 2 + params.leanR_p_w - const_var.roofRegularDst, params.leanR_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pR / 12 - thickness);
                            legModel.quadraticCurveTo(
                                params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pR / 12 / 10,
                                params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h + const_var.roofRegularDst
                            )
                        }else {
                            legModel.lineTo(params.p_w / 2 + newArr[legPos], params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - newArr[legPos] * params.b_l_t_r_p / 12);
                            legModel.lineTo(params.p_w / 2 + newArr[legPos], params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - newArr[legPos] * params.b_l_t_r_p / 12 - thickness);
                        }
                        legModel.lineTo(params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h  - thickness);
                        legModel.lineTo(params.p_w / 2 + params.leanR_p_w - thickness, 0 );
                    }else if(doorRef.current.userData.section == "frontlean" && rotationY === 0){
                        positionZ = 0
                        positionX = legPos + (thickness/2)
                        leanDimension = params.leanF_p_w
                        checkPos = positionX

                        legModel.moveTo(params.p_d / 2 + params.leanF_p_w, 0 );
                        legModel.lineTo(params.p_d / 2 + params.leanF_p_w, params.leanF_p_h);
                        if (params.p_r_s === 1) {
                            legModel.lineTo(params.p_d / 2 + params.leanF_p_w, params.leanF_p_h + const_var.roofRegularDst);
                            legModel.quadraticCurveTo(
                                params.p_d / 2 + params.leanF_p_w, params.leanF_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pF / 12 / 10,
                                params.p_d / 2 + params.leanF_p_w - const_var.roofRegularDst, params.leanF_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12
                            )
                            legModel.lineTo(params.p_d / 2 + newArr[legPos], params.leanF_p_h + params.b_l_t_r_pF / 12 * params.leanF_p_w - newArr[legPos] * params.b_l_t_r_pF / 12 + const_var.roofRegularDst * 2);
                            legModel.lineTo(params.p_d / 2 + newArr[legPos], params.leanF_p_h + params.b_l_t_r_pF / 12 * params.leanF_p_w - newArr[legPos] * params.b_l_t_r_pF / 12 + const_var.roofRegularDst * 2 -thickness);
                            legModel.lineTo(params.p_d / 2 + params.leanF_p_w - const_var.roofRegularDst, params.leanF_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12 - thickness);
                            legModel.quadraticCurveTo(
                                params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pF / 12 / 10,
                                params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h + const_var.roofRegularDst
                            )
                        }else {
                            legModel.lineTo(params.p_d / 2 + newArr[legPos], params.leanF_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - newArr[legPos] * params.b_l_t_r_pF / 12);
                            legModel.lineTo(params.p_d / 2 + newArr[legPos], params.leanF_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - newArr[legPos] * params.b_l_t_r_pF / 12 - thickness);
                        }
                        legModel.lineTo(params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h  - thickness);
                        legModel.lineTo(params.p_d / 2 + params.leanF_p_w - thickness, 0 );
                    }else if(doorRef.current.userData.section == "backlean" && rotationY === Math.PI){
                        positionZ = 0
                        positionX = -legPos + (thickness/2)
                        leanDimension = params.leanB_p_w
                        checkPos = positionX

                        legModel.moveTo(-params.p_d / 2 - params.leanB_p_w, 0 );
                        legModel.lineTo(-params.p_d / 2 - params.leanB_p_w, params.leanB_p_h);
                        if (params.p_r_s === 1) {
                            legModel.lineTo(-params.p_d / 2 - params.leanB_p_w, params.leanB_p_h + const_var.roofRegularDst);
                            legModel.quadraticCurveTo(
                                -params.p_d / 2 - params.leanB_p_w, params.leanB_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pB / 12 / 10,
                                -params.p_d / 2 - params.leanB_p_w + const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12
                            )
                            legModel.lineTo(-params.p_d / 2 - newArr[legPos], params.leanB_p_h + params.b_l_t_r_pB / 12 * params.leanB_p_w - newArr[legPos] * params.b_l_t_r_pB / 12 + const_var.roofRegularDst * 2);
                            legModel.lineTo(-params.p_d / 2 - newArr[legPos], params.leanB_p_h + params.b_l_t_r_pB / 12 * params.leanB_p_w - newArr[legPos] * params.b_l_t_r_pB / 12 + const_var.roofRegularDst * 2 - thickness);
                            legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12 - thickness);
                            legModel.quadraticCurveTo(
                                -params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pB / 12 / 10,
                                -params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h + const_var.roofRegularDst
                            )
                        } else {
                            legModel.lineTo(-params.p_d / 2 - newArr[legPos], params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w)) - newArr[legPos] * params.b_l_t_r_pB / 12);
                            legModel.lineTo(-params.p_d / 2 - newArr[legPos], params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w)) - newArr[legPos] * params.b_l_t_r_pB / 12 - thickness);
                        }
                        legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h  - thickness);
                        legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + thickness, 0 );
                    } else if(doorRef.current.userData.section == "gableLeftLean") {
                        positionZ = params.lean_p_pos;
                        if (rotationY === Math.PI) {
                            positionX = -legPos - thickness / 2 - 0.1;
                        } else {
                            positionX = legPos - thickness / 2 - 0.1;
                        }
                        rotation_y = Math.PI / 2;
                        legModel.moveTo(0 - params.lean_p_w / 2, 0 );
                        legModel.lineTo(0 - params.lean_p_w / 2, params.lean_p_h);
                        legModel.lineTo(0, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w / 2)));
                        legModel.lineTo(0 + params.lean_p_w / 2, params.lean_p_h);
                        legModel.lineTo(0 + params.lean_p_w / 2, 0 );
                        legModel.lineTo(0 + params.lean_p_w / 2 - thickness, 0 );
                        legModel.lineTo(0 + params.lean_p_w / 2 - thickness, params.lean_p_h - thickness);
                        legModel.lineTo(0, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w / 2)) - thickness);
                        legModel.lineTo(0 - params.lean_p_w / 2 + thickness, params.lean_p_h  - thickness);
                        legModel.lineTo(0 - params.lean_p_w / 2 + thickness, 0 );
                    } else if(doorRef.current.userData.section == "gableRightLean") {
                        positionZ = params.leanR_p_pos;
                        if (rotationY === Math.PI) {
                            positionX = -legPos - thickness / 2 + 0.1;
                        } else {
                            positionX = legPos - thickness / 2 + 0.1;
                        }
                        rotation_y = Math.PI / 2;
                        legModel.moveTo(0 - params.leanR_p_w / 2, 0 );
                        legModel.lineTo(0 - params.leanR_p_w / 2, params.leanR_p_h);
                        legModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w / 2)));
                        legModel.lineTo(0 + params.leanR_p_w / 2, params.leanR_p_h);
                        legModel.lineTo(0 + params.leanR_p_w / 2, 0 );
                        legModel.lineTo(0 + params.leanR_p_w / 2 - thickness, 0 );
                        legModel.lineTo(0 + params.leanR_p_w / 2 - thickness, params.leanR_p_h - thickness);
                        legModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w / 2)) - thickness);
                        legModel.lineTo(0 - params.leanR_p_w / 2 + thickness, params.leanR_p_h  - thickness);
                        legModel.lineTo(0 - params.leanR_p_w / 2 + thickness, 0 );
                    } else if(doorRef.current.userData.section == "gableFrontLean") {
                        positionX = params.leanF_p_pos;
                        if (rotationY === Math.PI / 2) {
                            positionZ = -legPos + thickness / 2;
                        } else {
                            positionZ = legPos + thickness / 2;
                        }
                        legModel.moveTo(0 - params.leanF_p_w / 2, 0 );
                        legModel.lineTo(0 - params.leanF_p_w / 2, params.leanF_p_h);
                        legModel.lineTo(0, params.leanF_p_h + ((params.b_l_t_r_pF/12)*(params.leanF_p_w / 2)));
                        legModel.lineTo(0 + params.leanF_p_w / 2, params.leanF_p_h);
                        legModel.lineTo(0 + params.leanF_p_w / 2, 0 );
                        legModel.lineTo(0 + params.leanF_p_w / 2 - thickness, 0 );
                        legModel.lineTo(0 + params.leanF_p_w / 2 - thickness, params.leanF_p_h - thickness);
                        legModel.lineTo(0, params.leanF_p_h + ((params.b_l_t_r_pF/12)*(params.leanF_p_w / 2)) - thickness);
                        legModel.lineTo(0 - params.leanF_p_w / 2 + thickness, params.leanF_p_h  - thickness);
                        legModel.lineTo(0 - params.leanF_p_w / 2 + thickness, 0 );
                    } else if(doorRef.current.userData.section == "gableBackLean") {
                        positionX = params.leanB_p_pos;
                        if (rotationY === Math.PI / 2) {
                            positionZ = -legPos - thickness * 3 / 2;
                        } else {
                            positionZ = legPos - thickness * 3 / 2;
                        }
                        legModel.moveTo(0 - params.leanB_p_w / 2, 0 );
                        legModel.lineTo(0 - params.leanB_p_w / 2, params.leanB_p_h);
                        legModel.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w / 2)));
                        legModel.lineTo(0 + params.leanB_p_w / 2, params.leanB_p_h);
                        legModel.lineTo(0 + params.leanB_p_w / 2, 0 );
                        legModel.lineTo(0 + params.leanB_p_w / 2 - thickness, 0 );
                        legModel.lineTo(0 + params.leanB_p_w / 2 - thickness, params.leanB_p_h - thickness);
                        legModel.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w / 2)) - thickness);
                        legModel.lineTo(0 - params.leanB_p_w / 2 + thickness, params.leanB_p_h  - thickness);
                        legModel.lineTo(0 - params.leanB_p_w / 2 + thickness, 0 );
                    }
                    if(doorRef.current.userData.section == "center") legModel.closePath();

                    let currentLeg = legGroup.getObjectByName(`${legPos}`)
                    let geometry = new THREE.ExtrudeGeometry(legModel, extrudeSettings(0.3))
                    if(((checkPos > (leanDimension/2) - (thickness/2))|| (checkPos < -(leanDimension/2) + (thickness/2))) && newArr[legPos] != undefined && doorRef.current.userData.section == "center"){
                        if(currentLeg != undefined) currentLeg.geometry = geometry
                    }
                    if(currentLeg == undefined){
                        let newLeg = intersectLeg.clone()
                        if(((checkPos > (leanDimension/2) - (thickness/2))|| (checkPos < -(leanDimension/2) + (thickness/2))) && newArr[legPos] != undefined && doorRef.current.userData.section == "center"){
                            newLeg.geometry = geometry
                        }
                        newLeg.visible = true
                        newLeg.name = `${legPos}`
                        newLeg.position.set(positionX,0,positionZ);
                        newLeg.rotation.set(0, rotation_y, 0);
                        if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean") newLeg.rotation.y = -Math.PI / 2
                        newLeg.updateMatrix()
                        newLeg.material.color.setHex("0x900000")
                        newLeg.material.depthTest = false
                        newLeg.material.transparent = false
                        newLeg.material.needsUpdate = true
                        newLeg.renderOrder = 5
                        legGroup.add(newLeg)
                    }else{
                        currentLeg.position.set(positionX,0,positionZ)
                        currentLeg.rotation.set(0, rotation_y, 0);
                        if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean") currentLeg.rotation.y = -Math.PI / 2
                        currentLeg.updateMatrix()
                        currentLeg.visible = true
                        currentLeg.material.transparent = false
                        currentLeg.material.needsUpdate = true
                        currentLeg.renderOrder = 5
                    }
                    }

                })
            }
            // Code end to highlight the legs which is intersecting the window
        }

    

        const handleMouseMove = e => {
            if(doorRef.current != undefined && currentComponent != undefined && currentComponent.name == doorRef.current.name && isDraggable == true){
                const { limitX, limitY, rotationY } = LimitValueOnWall("model", compType, wallName, width, height, doorRef.current.position.y, isDrag);
                let wall = scene.getObjectByName("intersectWall")
                let wallIntersect

                const rect = gl.domElement.getBoundingClientRect();
                const mouse = new THREE.Vector3();
                if(event.pointerType == "mouse"){
                    mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
                    mouse.y = 2 * -((e.clientY - rect.top) / rect.height) + 1;
                }else{
                    mouse.x = ((e.touches[0].clientX - rect.left) / rect.width) * 2 - 1;
                    mouse.y = 2 * -((e.touches[0].clientY - rect.top) / rect.height) + 1;
                }

                raycaster.setFromCamera(mouse, camera);
                if(wall != undefined) wallIntersect = raycaster.intersectObject(wall, true);
                let doorIntersect = raycaster.intersectObject(doorRef.current, true);

                if((wallIntersect != undefined && wallIntersect.length>0) || (doorIntersect != undefined && doorIntersect.length>0)){
                    const_var.componentsMoving = true;
                    get().gl.domElement.style.cursor = 'move'
                    let intersetedObject
                    if(wallIntersect != undefined && wallIntersect.length>0){
                        intersetedObject = wallIntersect[0].point
                    } else if (doorIntersect != undefined && doorIntersect.length>0){
                        intersetedObject = doorIntersect[0].point
                    }
                    
                    if(intersetedObject != undefined){


                    /*hight limit on component movement (Start)*/
                        let maxLimitObjX = findMaxLimitY(buildingType, wallName, height, width, componentDistance,doorRef.current.position.x, limitY.max)
                    /*hight limit on component movement (End)*/

                        let adjustedX;
                        if (rotationY === 0) {
                            adjustedX = intersetedObject.x;
                        } else if (rotationY === Math.PI) {
                            adjustedX = -intersetedObject.x;
                        } else if (rotationY === Math.PI / 2) {
                            adjustedX = -intersetedObject.z;
                        } else if (rotationY === -Math.PI / 2) {
                            adjustedX = intersetedObject.z;
                        }

                        let signX = Math.sign(adjustedX)
                        let mx = maxLimitObjX?.sectionHeight + (((maxLimitObjX?.sectionWidth / 2) - componentDistance) * (maxLimitObjX?.sectionPitch / 12)) - componentDistance;
                        let maxWidth = ((mx - (limitY.min + height / 2)) * 12) / maxLimitObjX?.sectionPitch;
                        let adjustedWidth = Math.abs(adjustedX + (width / 2) * signX);


                        if (maxLimitObjX.isEndSide ? (adjustedX < limitX.min && maxWidth >= adjustedWidth) : (adjustedX < limitX.min)) {
                            doorRef.current.position.x = limitX.min;
                            if (const_var.callMesure) setPositionX(limitX.min);
                        } else if (maxLimitObjX.isEndSide ? (adjustedX > limitX.max && maxWidth >= adjustedWidth) : (adjustedX > limitX.max)) {
                            doorRef.current.position.x = limitX.max;
                            if (const_var.callMesure) setPositionX(limitX.max);
                        } else if (maxWidth < adjustedWidth && maxLimitObjX.isEndSide) {
                            let newPos = (maxWidth - (width / 2)) * signX;
                            if(newPos < limitX.min) newPos =  limitX.min;
                            if(newPos > limitX.max) newPos =  limitX.max;
                            doorRef.current.position.x = newPos;
                            if (const_var.callMesure) setPositionX(newPos);
                        } else {
                            let finalValue = convertToAdjustedFeetInches(adjustedX, limitX.min);

                            let newPos = (maxWidth - (width / 2)) * signX;
                            if(newPos < limitX.min) newPos =  limitX.min;
                            if(newPos > limitX.max) newPos =  limitX.max;
                            doorRef.current.position.x = finalValue;
                            if (const_var.callMesure) setPositionX(finalValue);
                        }

                        let maxLimitObjY = findMaxLimitY(buildingType, wallName, height, width, componentDistance,doorRef.current.position.x, limitY.max)
                        
                        let minLimit = maxLimitObjY.maxLimit - (height/2) - componentDistance
                        
                        if (intersetedObject.y < limitY.min) {
                            if(const_var.callMesure) setPositionY(limitY.min);
                            doorRef.current.position.y = limitY.min
                        } else if (intersetedObject.y > maxLimitObjY?.maxLimit && minLimit >= 0) {
                            if(const_var.callMesure) setPositionY(maxLimitObjY?.maxLimit);
                            doorRef.current.position.y = maxLimitObjY?.maxLimit
                        } else if (minLimit < 0) {
                            if(const_var.callMesure) setPositionY(limitY.min);
                            doorRef.current.position.y = limitY.min
                        } else {
                            let finalValue = convertToAdjustedFeetInches(intersetedObject.y, limitY.min)
                            doorRef.current.position.y = finalValue
                            if(const_var.callMesure) setPositionY(finalValue);
                        }

                        trim1 = doorRef.current?.getObjectByName("trim")
                        // if(trim1 == undefined) trim1 = doorRef.current.getObjectByName("out-trim")
                        if(trim1 != undefined && trim1.isMesh && trim1.material.color.getHex() == "0x900000"){  
                            if( doorRef.current.userData.name.includes("black_window") ||
                                doorRef.current.userData.name.includes("black_half_net_window") || 
                                doorRef.current.userData.name.includes("window_with_black_4_grid_window") || 
                                doorRef.current.userData.name.includes("black_frame_with_standard_glass_window") || 
                                doorRef.current.userData.name.includes("black_double_pane_single_glass_window") || 
                                doorRef.current.userData.name.includes("window_with_black_grid_window")) {
                                    trim1.material.color.setHex("0x1F1F1F")
                                }else if(doorRef.current.userData.name.includes("window_with_white_6_grid_window") || doorRef.current.userData.name.includes("window_with_white_4_grid_window") || doorRef.current.userData.name.includes("double_pane_single_glass_with_white_trim_window")){
                                    trim1.material.color.setHex('0xffffff')
                                }else if(doorRef.current.userData.name.includes("4_grid_window_with_burnished_slate_trim_window") || doorRef.current.userData.name.includes("double_pane_single_glass_with_white_trim_window")){
                                    trim1.material.color.setHex('0x35352E')
                                }else if(doorRef.current.userData.name.includes("9_lite_black_door_with_x_pattern_walkin") || doorRef.current.userData.name.includes("double_pane_single_glass_with_white_trim_window")){
                                    trim1.material.color.setHex('0x000000')
                                }else{
                                    let wallName = const_var.checkWallClose[doorRef.current.userData.wallName];
                                    let WallState = params[wallName];
                                    if((WallState == "Open" && ((wallName != "p_r_w" && wallName != "p_l_w") || (!params.p_c_p_r && wallName == "p_r_w") || (!params.p_c_p_l && wallName == "p_l_w")))) trim1Color = '0xC8C8C8';
                                    trim1.material.color.setHex(trim1Color)
                                }
                            trim1.material.needsUpdate = true
                        }

                        doorArr.map((door)=>{
                            let uniqueName = `${door.userData.compName}_${door.userData.wallName}_${door.userData.uniqueId}_DoorWindows`
                            mesh2 = scene.getObjectByName(uniqueName)
                            if(mesh2 != undefined && mesh2.getObjectByName("trim") != undefined) trim2 = mesh2.getObjectByName("trim")
                            // if(trim2 == undefined && mesh2.getObjectByName("out-trim") != undefined) trim2 = mesh2.getObjectByName("out-trim")
                            if(trim2 != undefined && trim2.isMesh && trim2.material.color.getHex() == "0x900000" && trim2 != undefined){
                                if( mesh2.userData.name.includes("black_window") ||
                                    mesh2.userData.name.includes("black_half_net_window") || 
                                    mesh2.userData.name.includes("window_with_black_4_grid_window") || 
                                    mesh2.userData.name.includes("black_frame_with_standard_glass_window") || 
                                    mesh2.userData.name.includes("black_double_pane_single_glass_window") || 
                                    mesh2.userData.name.includes("window_with_black_grid_window")) {
                                        trim2.material.color.setHex("0x1F1F1F")
                                    }else if(mesh2.userData.name.includes("window_with_white_6_grid_window") || mesh2.userData.name.includes("window_with_white_4_grid_window") || mesh2.userData.name.includes("double_pane_single_glass_with_white_trim_window")){
                                        trim2.material.color.setHex('0xffffff')
                                    }else if(mesh2.userData.name.includes("4_grid_window_with_burnished_slate_trim_window") || mesh2.userData.name.includes("double_pane_single_glass_with_white_trim_window")){
                                        trim2.material.color.setHex('0x35352E')
                                    }else if(mesh2.userData.name.includes("9_lite_black_door_with_x_pattern_walkin") || mesh2.userData.name.includes("double_pane_single_glass_with_white_trim_window")){
                                        trim2.material.color.setHex('0x000000')
                                    }else{
                                        let wallName = const_var.checkWallClose[door.userData.wallName];
                                        let WallState = params[wallName];
                                        if((WallState == "Open" && ((wallName != "p_r_w" && wallName != "p_l_w") || (!params.p_c_p_r && wallName == "p_r_w") || (!params.p_c_p_l && wallName == "p_l_w")))) trim2Color = '0xC8C8C8';
                                        trim2.material.color.setHex(trim2Color)
                                    }
                                trim2.material.needsUpdate = true
                            }
                            if(doorRef.current.position.x + componentDistance +width/2 > door.positionX - door.width/2 && 
                                doorRef.current.position.x - componentDistance - width/2 < door.positionX + door.width/2 &&
                                doorRef.current.position.y + componentDistance +height/2 > door.positionY - door.height/2 && 
                                doorRef.current.position.y - componentDistance - height/2 < door.positionY + door.height/2
                            ){
                                trim1 = doorRef.current?.getObjectByName("trim")
                                // if(trim1 == undefined) trim1 = doorRef.current.getObjectByName("out-trim")
                                mesh2 = scene.getObjectByName(uniqueName)
                                if(mesh2 != undefined) trim2 = mesh2.getObjectByName("trim")
                                if(trim1 != undefined && trim1.isMesh){
                                    trim1.material.color.setHex("0x900000")
                                    trim1.material.needsUpdate = true
                                }
                                if(trim2 != undefined && trim2.isMesh){
                                    trim2.material.color.setHex("0x900000")
                                    trim2.material.needsUpdate = true
                                }  
                            }
                        })

                        // Code start to highlight the legs which is intersecting the window
                        if(doorRef.current.userData.section != undefined && 
                            (
                                (doorRef.current.userData.section == "center" && (rotationY === -Math.PI / 2 || rotationY === Math.PI / 2)) || 
                                (doorRef.current.userData.section == "leftlean" && rotationY === -Math.PI / 2) ||
                                (doorRef.current.userData.section == "rightlean" && rotationY === Math.PI / 2) ||
                                (doorRef.current.userData.section == "frontlean" && rotationY === 0) ||
                                (doorRef.current.userData.section == "backlean" && rotationY === Math.PI) ||
                                (doorRef.current.userData.section == "gableLeftLean" && (rotationY === Math.PI || rotationY === 0)) ||
                                (doorRef.current.userData.section == "gableRightLean" && (rotationY === Math.PI || rotationY === 0)) ||
                                (doorRef.current.userData.section == "gableFrontLean" && (rotationY === -Math.PI / 2 || rotationY === Math.PI / 2)) ||
                                (doorRef.current.userData.section == "gableBackLean" && (rotationY === -Math.PI / 2 || rotationY === Math.PI / 2))
                            )
                        ){
                            let legPosArr = []
                            let key = doorRef.current.userData.section;
                            if (doorRef.current.userData.section === 'center') {
                                legPosArr = const_var.leanToLegPosObj[key].filter((leg)=>doorRef.current.position.x - (width/2) <= leg && doorRef.current.position.x + (width/2) >= leg)
                            } else if (doorRef.current.userData.section.includes("gable")) {
                                legPosArr = const_var.leanToLegPosObj[key].filter((leg)=>Math.abs(doorRef.current.position.x) - (width/2) <= Math.abs(leg) && Math.abs(doorRef.current.position.x) + (width/2) >= Math.abs(leg))
                                if (doorRef.current.userData.section.includes("Right")) {
                                    if (doorRef.current.position.x < 0) legPosArr = legPosArr.map(item => -item)
                                } else {
                                    if (doorRef.current.position.x > 0) legPosArr = legPosArr.map(item => -item)
                                }
                            } else {
                                key = key.replace("lean", "")
                                legPosArr = const_var.leanToLegPosObj[key].filter((leg)=>doorRef.current.position.x - (width/2) <= leg && doorRef.current.position.x + (width/2) >= leg)
                            }
            
                            let intersectLeg = scene.getObjectByName("intersectLeg")

                            if(intersectLeg != undefined){
                                legPosArr.map((legPos)=>{
                                
                                    let newArr = {}
                                    if(doorRef.current.userData.section != "center" && !doorRef.current.userData.section.includes("gable")){
                                        let key = doorRef.current.userData.section.replace("lean", "");
                                        let closestPositive = const_var.leanToLegPosObj[key].reduce((a, b) => {
                                            return Math.abs(b - (params.p_d/2)) < Math.abs(a - (params.p_d/2)) ? b : a;
                                        });
                                        let closestNegative = const_var.leanToLegPosObj[key].reduce((a, b) => {
                                            return Math.abs(b - (params.p_d/-2)) < Math.abs(a - (params.p_d/-2)) ? b : a;
                                        });
                                        let lengthIndexPositive = const_var.leanToLegPosObj[key]?.findIndex((num) => num >= closestPositive)
                                        let lengthIndexNegative = const_var.leanToLegPosObj[key]?.findIndex((num) => num >= closestNegative)
                                        if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean"){
                                            let closestPositive = const_var.leanToLegPosObj[key].reduce((a, b) => {
                                                return Math.abs(b - (params.p_w/2)) < Math.abs(a - (params.p_w/2)) ? b : a;
                                            });
                                            let closestNegative = const_var.leanToLegPosObj[key].reduce((a, b) => {
                                                return Math.abs(b - (params.p_w/-2)) < Math.abs(a - (params.p_w/-2)) ? b : a;
                                            });
                                            lengthIndexPositive = const_var.leanToLegPosObj[key]?.findIndex((num) => num == closestPositive)
                                            lengthIndexNegative = const_var.leanToLegPosObj[key]?.findIndex((num) => num == closestNegative)
                                        }
                                        
                                        let j = 1
                                        for (let i = lengthIndexPositive+1; i <=  const_var.leanToLegPosObj[key].length-1; i++) {  
                                            newArr[const_var.leanToLegPosObj[key][i]] = distance1*j
                                            j++
                                        }

                                        let k = 1
                                        for (let i = lengthIndexNegative-1; i >  0; i--) {  
                                            newArr[const_var.leanToLegPosObj[key][i]] = distance1*k
                                            k++
                                        }
                                    }
                                    
                                    
                                    let positionX = 0
                                    let positionZ = legPos - (thickness/2)
                                    let rotation_y = 0;
                                    let leanDimension = params.lean_p_d
                                    let checkPos = positionZ
                                    const legModel = new THREE.Shape();
                                    if (doorRef.current.userData.section == "center" && rotationY === -Math.PI / 2){
                                        positionZ = legPos - (thickness/2)
                                    }else if(doorRef.current.userData.section == "center" && rotationY === Math.PI / 2){
                                        positionZ = -legPos - (thickness/2)
                                    }else if(doorRef.current.userData.section == "leftlean" && rotationY === -Math.PI / 2){
                                        positionZ = legPos - (thickness/2)
                                        leanDimension = params.lean_p_d
                                        checkPos = positionZ

                                        legModel.moveTo(-params.p_w / 2 - params.lean_p_w, 0 );
                                        legModel.lineTo(-params.p_w / 2 - params.lean_p_w, params.lean_p_h);
                                        if (params.p_r_s === 1) {
                                            legModel.lineTo(-params.p_w / 2 - params.lean_p_w, params.lean_p_h + const_var.roofRegularDst);
                                            legModel.quadraticCurveTo(
                                                -params.p_w / 2 - params.lean_p_w, params.lean_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_p / 12 / 10,
                                                -params.p_w / 2 - params.lean_p_w + const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12
                                            )
                                            legModel.lineTo(-params.p_w / 2 - newArr[legPos], params.lean_p_h + params.b_l_t_r_p / 12 * params.lean_p_w + const_var.roofRegularDst * 2 - newArr[legPos] * params.b_l_t_r_p / 12);
                                            legModel.lineTo(-params.p_w / 2 - newArr[legPos], params.lean_p_h + params.b_l_t_r_p / 12 * params.lean_p_w + const_var.roofRegularDst * 2 - newArr[legPos] * params.b_l_t_r_p / 12 - thickness);
                                            legModel.lineTo(-params.p_w / 2 - params.lean_p_w + const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12 - thickness);
                                            legModel.quadraticCurveTo(
                                                -params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_p / 12 / 10,
                                                -params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h + const_var.roofRegularDst
                                            )
                                        } else {
                                            legModel.lineTo(-params.p_w / 2 - newArr[legPos], params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w)) - newArr[legPos] * params.b_l_t_r_p / 12);
                                            legModel.lineTo(-params.p_w / 2 - newArr[legPos], params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w)) - newArr[legPos] * params.b_l_t_r_p / 12 - thickness);
                                        }
                                        legModel.lineTo(-params.p_w / 2 - params.lean_p_w + thickness, params.lean_p_h  - thickness);
                                        legModel.lineTo(-params.p_w / 2 - params.lean_p_w + thickness, 0 );
                                    }else if(doorRef.current.userData.section == "rightlean" && rotationY === Math.PI / 2){
                                        positionZ = -legPos - (thickness/2)
                                        leanDimension = params.leanR_p_d
                                        checkPos = positionZ

                                        legModel.moveTo(params.p_w / 2 + params.leanR_p_w, 0 );
                                        legModel.lineTo(params.p_w / 2 + params.leanR_p_w, params.leanR_p_h);
                                        if (params.p_r_s === 1) {
                                            legModel.lineTo(params.p_w / 2 + params.leanR_p_w, params.leanR_p_h + const_var.roofRegularDst);
                                            legModel.quadraticCurveTo(
                                                params.p_w / 2 + params.leanR_p_w, params.leanR_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pR / 12 / 10,
                                                params.p_w / 2 + params.leanR_p_w - const_var.roofRegularDst, params.leanR_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pR / 12
                                            )
                                            legModel.lineTo(params.p_w / 2 + newArr[legPos], params.leanR_p_h + params.b_l_t_r_pR / 12 * params.leanR_p_w + const_var.roofRegularDst * 2 - newArr[legPos] * params.b_l_t_r_p / 12);
                                            legModel.lineTo(params.p_w / 2 + newArr[legPos], params.leanR_p_h + params.b_l_t_r_pR / 12 * params.leanR_p_w + const_var.roofRegularDst * 2 - newArr[legPos] * params.b_l_t_r_p / 12 -thickness);
                                            legModel.lineTo(params.p_w / 2 + params.leanR_p_w - const_var.roofRegularDst, params.leanR_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pR / 12 - thickness);
                                            legModel.quadraticCurveTo(
                                                params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pR / 12 / 10,
                                                params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h + const_var.roofRegularDst
                                            )
                                        }else {
                                            legModel.lineTo(params.p_w / 2 + newArr[legPos], params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - newArr[legPos] * params.b_l_t_r_p / 12);
                                            legModel.lineTo(params.p_w / 2 + newArr[legPos], params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - newArr[legPos] * params.b_l_t_r_p / 12 - thickness);
                                        }
                                        legModel.lineTo(params.p_w / 2 + params.leanR_p_w - thickness, params.leanR_p_h  - thickness);
                                        legModel.lineTo(params.p_w / 2 + params.leanR_p_w - thickness, 0 );
                                    }else if(doorRef.current.userData.section == "frontlean" && rotationY === 0){
                                        positionZ = 0
                                        positionX = legPos + (thickness/2)
                                        leanDimension = params.leanF_p_w
                                        checkPos = positionX

                                        legModel.moveTo(params.p_d / 2 + params.leanF_p_w, 0 );
                                        legModel.lineTo(params.p_d / 2 + params.leanF_p_w, params.leanF_p_h);
                                        if (params.p_r_s === 1) {
                                            legModel.lineTo(params.p_d / 2 + params.leanF_p_w, params.leanF_p_h + const_var.roofRegularDst);
                                            legModel.quadraticCurveTo(
                                                params.p_d / 2 + params.leanF_p_w, params.leanF_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pF / 12 / 10,
                                                params.p_d / 2 + params.leanF_p_w - const_var.roofRegularDst, params.leanF_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12
                                            )
                                            legModel.lineTo(params.p_d / 2 + newArr[legPos], params.leanF_p_h + params.b_l_t_r_pF / 12 * params.leanF_p_w - newArr[legPos] * params.b_l_t_r_pF / 12 + const_var.roofRegularDst * 2);
                                            legModel.lineTo(params.p_d / 2 + newArr[legPos], params.leanF_p_h + params.b_l_t_r_pF / 12 * params.leanF_p_w - newArr[legPos] * params.b_l_t_r_pF / 12 + const_var.roofRegularDst * 2 -thickness);
                                            legModel.lineTo(params.p_d / 2 + params.leanF_p_w - const_var.roofRegularDst, params.leanF_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12 - thickness);
                                            legModel.quadraticCurveTo(
                                                params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pF / 12 / 10,
                                                params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h + const_var.roofRegularDst
                                            )
                                        }else {
                                            legModel.lineTo(params.p_d / 2 + newArr[legPos], params.leanF_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - newArr[legPos] * params.b_l_t_r_pF / 12);
                                            legModel.lineTo(params.p_d / 2 + newArr[legPos], params.leanF_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w)) - newArr[legPos] * params.b_l_t_r_pF / 12 - thickness);
                                        }
                                        legModel.lineTo(params.p_d / 2 + params.leanF_p_w - thickness, params.leanF_p_h  - thickness);
                                        legModel.lineTo(params.p_d / 2 + params.leanF_p_w - thickness, 0 );
                                    }else if(doorRef.current.userData.section == "backlean" && rotationY === Math.PI){
                                        positionZ = 0
                                        positionX = -legPos + (thickness/2)
                                        leanDimension = params.leanB_p_w
                                        checkPos = positionX

                                        legModel.moveTo(-params.p_d / 2 - params.leanB_p_w, 0 );
                                        legModel.lineTo(-params.p_d / 2 - params.leanB_p_w, params.leanB_p_h);
                                        if (params.p_r_s === 1) {
                                            legModel.lineTo(-params.p_d / 2 - params.leanB_p_w, params.leanB_p_h + const_var.roofRegularDst);
                                            legModel.quadraticCurveTo(
                                                -params.p_d / 2 - params.leanB_p_w, params.leanB_p_h + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pB / 12 / 10,
                                                -params.p_d / 2 - params.leanB_p_w + const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12
                                            )
                                            legModel.lineTo(-params.p_d / 2 - newArr[legPos], params.leanB_p_h + params.b_l_t_r_pB / 12 * params.leanB_p_w - newArr[legPos] * params.b_l_t_r_pB / 12 + const_var.roofRegularDst * 2);
                                            legModel.lineTo(-params.p_d / 2 - newArr[legPos], params.leanB_p_h + params.b_l_t_r_pB / 12 * params.leanB_p_w - newArr[legPos] * params.b_l_t_r_pB / 12 + const_var.roofRegularDst * 2 - thickness);
                                            legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12 - thickness);
                                            legModel.quadraticCurveTo(
                                                -params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h - thickness + const_var.roofRegularDst * 1.8 + const_var.roofRegularDst * params.b_l_t_r_pB / 12 / 10,
                                                -params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h + const_var.roofRegularDst
                                            )
                                        } else {
                                            legModel.lineTo(-params.p_d / 2 - newArr[legPos], params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w)) - newArr[legPos] * params.b_l_t_r_pB / 12);
                                            legModel.lineTo(-params.p_d / 2 - newArr[legPos], params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w)) - newArr[legPos] * params.b_l_t_r_pB / 12 - thickness);
                                        }
                                        legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + thickness, params.leanB_p_h  - thickness);
                                        legModel.lineTo(-params.p_d / 2 - params.leanB_p_w + thickness, 0 );
                                    } else if(doorRef.current.userData.section == "gableLeftLean"){
                                        positionZ = params.lean_p_pos;
                                        if (rotationY === Math.PI) {
                                            positionX = -legPos - thickness / 2 - 0.1;
                                        } else {
                                            positionX = legPos - thickness / 2 - 0.1;
                                        }
                                        rotation_y = Math.PI / 2;
                                        legModel.moveTo(0 - params.lean_p_w / 2, 0 );
                                        legModel.lineTo(0 - params.lean_p_w / 2, params.lean_p_h);
                                        legModel.lineTo(0, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w / 2)));
                                        legModel.lineTo(0 + params.lean_p_w / 2, params.lean_p_h);
                                        legModel.lineTo(0 + params.lean_p_w / 2, 0 );
                                        legModel.lineTo(0 + params.lean_p_w / 2 - thickness, 0 );
                                        legModel.lineTo(0 + params.lean_p_w / 2 - thickness, params.lean_p_h - thickness);
                                        legModel.lineTo(0, params.lean_p_h + ((params.b_l_t_r_p/12)*(params.lean_p_w / 2)) - thickness);
                                        legModel.lineTo(0 - params.lean_p_w / 2 + thickness, params.lean_p_h  - thickness);
                                        legModel.lineTo(0 - params.lean_p_w / 2 + thickness, 0 );
                                    } else if(doorRef.current.userData.section == "gableRightLean") {
                                        positionZ = params.leanR_p_pos;
                                        if (rotationY === Math.PI) {
                                            positionX = -legPos - thickness / 2 + 0.1;
                                        } else {
                                            positionX = legPos - thickness / 2 + 0.1;
                                        }
                                        rotation_y = Math.PI / 2;
                                        legModel.moveTo(0 - params.leanR_p_w / 2, 0 );
                                        legModel.lineTo(0 - params.leanR_p_w / 2, params.leanR_p_h);
                                        legModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w / 2)));
                                        legModel.lineTo(0 + params.leanR_p_w / 2, params.leanR_p_h);
                                        legModel.lineTo(0 + params.leanR_p_w / 2, 0 );
                                        legModel.lineTo(0 + params.leanR_p_w / 2 - thickness, 0 );
                                        legModel.lineTo(0 + params.leanR_p_w / 2 - thickness, params.leanR_p_h - thickness);
                                        legModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR/12)*(params.leanR_p_w / 2)) - thickness);
                                        legModel.lineTo(0 - params.leanR_p_w / 2 + thickness, params.leanR_p_h  - thickness);
                                        legModel.lineTo(0 - params.leanR_p_w / 2 + thickness, 0 );
                                    } else if(doorRef.current.userData.section == "gableFrontLean") {
                                        positionX = params.leanF_p_pos;
                                        if (rotationY === Math.PI / 2) {
                                            positionZ = -legPos + thickness / 2;
                                        } else {
                                            positionZ = legPos + thickness / 2;
                                        }
                                        legModel.moveTo(0 - params.leanF_p_w / 2, 0 );
                                        legModel.lineTo(0 - params.leanF_p_w / 2, params.leanF_p_h);
                                        legModel.lineTo(0, params.leanF_p_h + ((params.b_l_t_r_pF/12)*(params.leanF_p_w / 2)));
                                        legModel.lineTo(0 + params.leanF_p_w / 2, params.leanF_p_h);
                                        legModel.lineTo(0 + params.leanF_p_w / 2, 0 );
                                        legModel.lineTo(0 + params.leanF_p_w / 2 - thickness, 0 );
                                        legModel.lineTo(0 + params.leanF_p_w / 2 - thickness, params.leanF_p_h - thickness);
                                        legModel.lineTo(0, params.leanF_p_h + ((params.b_l_t_r_pF/12)*(params.leanF_p_w / 2)) - thickness);
                                        legModel.lineTo(0 - params.leanF_p_w / 2 + thickness, params.leanF_p_h  - thickness);
                                        legModel.lineTo(0 - params.leanF_p_w / 2 + thickness, 0 );
                                    } else if(doorRef.current.userData.section == "gableBackLean") {
                                        positionX = params.leanB_p_pos;
                                        if (rotationY === Math.PI / 2) {
                                            positionZ = -legPos - thickness * 3 / 2;
                                        } else {
                                            positionZ = legPos - thickness * 3 / 2;
                                        }
                                        legModel.moveTo(0 - params.leanB_p_w / 2, 0 );
                                        legModel.lineTo(0 - params.leanB_p_w / 2, params.leanB_p_h);
                                        legModel.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w / 2)));
                                        legModel.lineTo(0 + params.leanB_p_w / 2, params.leanB_p_h);
                                        legModel.lineTo(0 + params.leanB_p_w / 2, 0 );
                                        legModel.lineTo(0 + params.leanB_p_w / 2 - thickness, 0 );
                                        legModel.lineTo(0 + params.leanB_p_w / 2 - thickness, params.leanB_p_h - thickness);
                                        legModel.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB/12)*(params.leanB_p_w / 2)) - thickness);
                                        legModel.lineTo(0 - params.leanB_p_w / 2 + thickness, params.leanB_p_h  - thickness);
                                        legModel.lineTo(0 - params.leanB_p_w / 2 + thickness, 0 );
                                    }
                                    if(doorRef.current.userData.section != "center") legModel.closePath();

                                    let currentLeg = legGroup.getObjectByName(`${legPos}`)
                                    let geometry = new THREE.ExtrudeGeometry(legModel, extrudeSettings(0.3))
                                    if(((checkPos > (leanDimension/2) - (thickness/2))|| (checkPos < -(leanDimension/2) + (thickness/2))) && newArr[legPos] != undefined && doorRef.current.userData.section != "center"){
                                        if(currentLeg != undefined) currentLeg.geometry = geometry
                                    }
                                    if(currentLeg == undefined){
                                        let newLeg = intersectLeg.clone()
                                        if(((checkPos > (leanDimension/2) - (thickness/2))|| (checkPos < -(leanDimension/2) + (thickness/2))) && newArr[legPos] != undefined && doorRef.current.userData.section != "center"){
                                            newLeg.geometry = geometry
                                        }
                                        newLeg.name = `${legPos}`
                                        newLeg.visible = true
                                        newLeg.position.set(positionX,0,positionZ)
                                        newLeg.rotation.set(0, rotation_y, 0);
                                        if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean") newLeg.rotation.y = -Math.PI / 2
                                        newLeg.updateMatrixWorld()
                                        newLeg.material.color.setHex("0x900000")
                                        newLeg.material.depthTest = false
                                        newLeg.material.transparent = false
                                        newLeg.material.needsUpdate = true
                                        newLeg.renderOrder = 5
                                        legGroup.add(newLeg)
                                    }else{
                                        currentLeg.position.set(positionX,0,positionZ)
                                        currentLeg.rotation.set(0, rotation_y, 0);
                                        if(doorRef.current.userData.section == "frontlean" || doorRef.current.userData.section == "backlean") currentLeg.rotation.y = -Math.PI / 2
                                        currentLeg.updateMatrixWorld()
                                        currentLeg.visible = true
                                        currentLeg.material.transparent = false
                                        currentLeg.material.needsUpdate = true
                                        currentLeg.renderOrder = 5
                                    }
                                })
                                
                                legGroup.children.map((leg)=>{
                                    let currentLeg = legGroup.getObjectByName(`${leg.name}`)
                                    if(currentLeg != undefined){
                                        const isExist = legPosArr.indexOf(Number(currentLeg.name)) !== -1;
                                        if(!isExist){
                                            legGroup.remove(currentLeg)
                                        }
                                    }
                                })
                            }
                        }
                        // Code end to highlight the legs which is intersecting the window
                    }
                }else{
                    get().gl.domElement.style.cursor = 'auto'
                }
            }
        };
    
        
        const handleMouseUp = e => {
    
            legGroup.children = []
            const_var.controls.enableRotate = true;
            get().gl.domElement.style.cursor = 'auto'
            const_var.controls.update();

            limitX.max = LimitValueOnWall("model", compType, wallName, width, height, doorRef.current.position.y, isDrag).limitX.max;
            limitX.min = LimitValueOnWall("model", compType, wallName, width, height, doorRef.current.position.y, isDrag).limitX.min;
            limitY.max = LimitValueOnWall("model", compType, wallName, width, height, doorRef.current.position.y, isDrag).limitY.max;
            limitY.min = LimitValueOnWall("model", compType, wallName, width, height, doorRef.current.position.y, isDrag).limitY.min;
    
            doorArr.map((door)=>{
                let uniqueName = `${door.userData.compName}_${door.userData.wallName}_${door.userData.uniqueId}_DoorWindows`
                let mesh = scene.getObjectByName(uniqueName)
                let trim
                if(mesh != undefined && mesh2!= undefined && mesh2.getObjectByName("trim") != undefined) trim = mesh.getObjectByName("trim")
                if(trim != undefined && trim.isMesh && trim.material.color.getHex() == "0x900000"){
                    if( mesh.userData.name.includes("black_window") ||
                        mesh.userData.name.includes("black_half_net_window") || 
                        mesh.userData.name.includes("window_with_black_4_grid_window") || 
                        mesh.userData.name.includes("black_frame_with_standard_glass_window") || 
                        mesh.userData.name.includes("black_double_pane_single_glass_window") || 
                        mesh.userData.name.includes("window_with_black_grid_window")) {
                            trim.material.color.setHex("0x1F1F1F")
                        }else if(mesh.userData.name.includes("window_with_white_6_grid_window") || mesh.userData.name.includes("window_with_white_4_grid_window") || mesh.userData.name.includes("double_pane_single_glass_with_white_trim_window")){
                            trim.material.color.setHex('0xffffff')
                        }else if(mesh.userData.name.includes("4_grid_window_with_burnished_slate_trim_window")) {
                            trim.material.color.setHex('0x35352E')
                        }else if(mesh.userData.name.includes("9_lite_black_door_with_x_pattern_walkin")) {
                            trim.material.color.setHex('0x000000')
                        }
                        else{
                            trim.material.color.setHex(trim2Color)
                        }
                    trim.material.needsUpdate = true
                }
            })
            
            let trim2 = doorRef.current?.getObjectByName("trim")
            if(trim2 != undefined && trim2.isMesh && trim2.material.color.getHex() == "0x900000"){
                if( doorRef.current.userData.name.includes("black_window") ||
                    doorRef.current.userData.name.includes("black_half_net_window") || 
                    doorRef.current.userData.name.includes("window_with_black_4_grid_window") || 
                    doorRef.current.userData.name.includes("black_frame_with_standard_glass_window") || 
                    doorRef.current.userData.name.includes("black_double_pane_single_glass_window") || 
                    doorRef.current.userData.name.includes("window_with_black_grid_window")) {
                        trim2.material.color.setHex("0x1F1F1F")
                    }else if(doorRef.current.userData.name.includes("window_with_white_6_grid_window") || doorRef.current.userData.name.includes("window_with_white_4_grid_window") || doorRef.current.userData.name.includes("double_pane_single_glass_with_white_trim_window")){
                        trim2.material.color.setHex('0xffffff')
                    }else if(doorRef.current.userData.name.includes("4_grid_window_with_burnished_slate_trim_window")) {
                        trim2.material.color.setHex('0x35352E')
                    }else if(doorRef.current.userData.name.includes("9_lite_black_door_with_x_pattern_walkin")) {
                        trim2.material.color.setHex('0x000000')
                    }else{
                        trim2.material.color.setHex(trim1Color)
                    }
                trim2.material.needsUpdate = true
            }

            if(isDraggable){
    
                setPositionX(doorRef.current.position.x)
                setPositionY(doorRef.current.position.y)
                
                let isFind = false;
                let isSetPosition = false;
                const doorsArray = [...const_var.newDoorsArray];
                const overlapDoorArrTemp = Overlap(sideArray, id, width, height, doorRef.current.position.x, doorRef.current.position.y, componentDistance, wallName);
                if (overlapDoorArrTemp.length > 0) isFind = true;
    
                revertPosOfCmp(doorsArray, wallName)
    
                if((doorRef.current.position.x < limitX.min - 0.2 || doorRef.current.position.x > limitX.max + 0.2)) {
                    isSetPosition = false;
                } else {
                    isSetPosition = true;
                }
    
                revertPosOfCmp(doorsArray, wallName)
                
                if (isFind || !isSetPosition) {
                    setPositionX(startPositionXY.x);
                    doorRef.current.position.x = startPositionXY.x
                    setPositionY(startPositionXY.y);
                    doorRef.current.position.y = startPositionXY.y
                } else {
                    setStartPositionXY({ x: doorRef.current.position.x, y: doorRef.current.position.y });
                    dispatch(actionCreator.updateDoorWindowPosition(id, doorRef.current.position.x, doorRef.current.position.y));
                    dispatch(actionCreator.updateDoorWindowLimitPosition(id, limitX.min, limitX.max));
                }
            }
    
            let intersectWall = scene.getObjectByName("intersectWall")
            let intersectLeg = scene.getObjectByName("intersectLeg")
            
            if(intersectWall != undefined){
                scene.remove(intersectWall)
                scene.remove(intersectLeg)
            }
    
            setIsDrag(false)
            isDraggable = false

            if(event.pointerType == "mouse"){
                document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp);
            }else{
                document.removeEventListener("touchmove", handleMouseMove);
                document.removeEventListener("touchend", handleMouseUp);
            }
            clearTimeout(const_var.timer);
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                handleMouseUp()
            } else {
                document.removeEventListener("visibilitychange", handleVisibilityChange);
            }
        }

        if(event.pointerType == "mouse"){
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
            document.addEventListener("visibilitychange", handleVisibilityChange);
        }else{
            document.addEventListener("touchmove", handleMouseMove);
            document.addEventListener("touchend", handleMouseUp);
        }
    }
        
        //  
    };

    return isAvailablePlace && (
        <group rotation={[0, rotationY, 0]}>

           <group position={[isDrag ? positionX : defaultPositionX, positionY,  isDrag ? positionZ + 0.3 : positionZ]} >
                <group name='Measurements-window' position={[0, 0, isDrag ? -0.2 : 0]} {...eventHandlers}>
                    <WindowMeasurements isDrag={isDrag} bindDelta={bindDelta} positionX={positionX} positionY={positionY} positionZ={positionZ} height={height} width={width} wallName={wallName} id={id} />
                </group>
            </group>

            <group 
                name={`${compName}_${wallName}_${id}_DoorWindows`}
                ref={doorRef}
                position={[isDrag ? positionX : defaultPositionX, positionY,  isDrag ? positionZ + 0.3 : positionZ]} 
                onClick={onClickDoorComponent}
                onPointerOver={(e) => {
                    let isDoorTransparent = checkDoorTransparent();
                    setCanClone(true);
                    // e.stopPropagation();
                    if ((controls.isCheckActiveTab !== 'leantos') && (((controls.isCheckActiveTab === 'doorwindow' || params.is_translusant) ? (!isDoorTransparent) : true)) && const_var.controls.enableRotate) {
                        setIsHovered(true)
                    }
                }}
                onPointerOut={() => setIsHovered(false)}
                userData={{"section":wallnameBySec[wallName],"wallName":wallName,"name":`${compName}${id}`}}
                onPointerDown={e=>handleMouseDown(e,"window")}
            >

                {/* <CenterArrow isDrag={isDrag} positionX={positionX} positionY={positionY} height={height} wallName={wallName} /> */}


                {/******************* Window *******************/}
                {compName === 'standard_window' && compType === 'window_frameout' && <FrameoutWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} trimColor={trimColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'standard_window' && compType !== 'window_frameout' && <StandardWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'single_vent_window' && <SingleVent width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'window_with_white_6_grid_window' && <StandardWindowWhiteTrim width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === '9_panel_(3x3_grid)_window' && <NinePanelWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {(compName !== '6_grid_window_with_black_trim_window' && compName !== 'black_frame_with_standard_glass_window' && compName !== 'black_half_net_window' && compName !== 'black_transom_6_grid_window' && compName !== 'black_transom_5_grid_window' && compName !== 'window_with_black_grid_window' && compName != "black_double_pane_single_glass_window" && (compName === 'window_with_black_4_grid_window' || compName === 'black_window' || compName.includes('black'))) && <FourGridBlackWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'window_with_black_grid_window' && <EightGridBlackWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'black_frame_with_standard_glass_window' && <BlackFrameStandardGlassWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'black_half_net_window' && <BlackFrameHalfNetWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {/* {compName === 'shutter_window' || compName.includes('shutter') && <ShutterWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} transparentState={transparentState} opacityValue={opacityValue}/> } */}
                {compName === 'shutter_window' && <ShutterWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'window_8_grid_window' && <WindowEightGridWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'window_with_white_4_grid_window' && <WhiteWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'window_without_shutters_window' && <WindowWithoutShuttersWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'window_with_shutters_window' && <WindowWithShuttersWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'window_with_shutters_4_grid_window' && <WindowWithShuttersFourGridWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'window_with_shutters_6_grid_window' && <WindowWithShuttersSixGridWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {(compName === 'double_pane_window' || compName ==='double_pane_single_glass_window') && <DoublePaneWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {(compName === 'double_pane_black_window' || compName.includes('black_double_pane_single_glass_window'))&& <DoublePaneBlackWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} trimColor={trimColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//>}
                {compName.includes('double_pane_single_glass_with_white_trim_window') && <DoublePaneWhiteWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} trimColor={trimColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//>}
                {compName === 'transomWindow' || compName.includes('transom_window') && <TransomWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'black_transom_5_grid_window' && <TransomFiveGridBlackWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'transom_6_grid_window' && <TransomSixGridWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'black_transom_6_grid_window' && <TransomSixGridBlackWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'faux_window_window' && <FauxWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'six_glasses_window' && <SixGlassesWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === 'bronze_window_with_4_grid_window' && <BronzeWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === '4_grid_window_with_burnished_slate_trim_window' && <NewBronzeWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName === '6_grid_window_with_black_trim_window' && <SixGridWindowBlackTrim width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//> }
                {compName.includes('double_pane_single_glass_with_white_trim_window') && <DoublePaneWhiteWindow width={width} height={height} trimWidth={trimWidth} doorColor={doorColor} isOverlap={overlapDoorArr.find((item) => item === id) === undefined ? false : true} trimColor={trimColor}  overlapTrimColor={overlapTrimColor} glassTexture={glassTexture} /* transparentState={transparentState} opacityValue={opacityValue} *//>}


                {selectedCmpType === 'window' && isShowEditIconSection && const_var.doorUniqueId === id && !isDoorTransparent && /* !transparentState && */ (
                    <Html key={occludeState} ref={editRef} position={[width / 1.8, height / 1.8, 1]} className='edit-btn-section' occlude={occludeState}>
                        <div onClick={() => {setCanClone(true); setIsDelBtnClicked(false); onClickEditButton()}} className='edit-icon-container'>
                            {
                                !const_var.showComponentEditBox ?
                                <i className='icon-edit-ico'></i>:
                                <i className='icon-close'></i>
                            }
                        </div>
                        <div onClick={(e) => {setDelTooltipPosition(e); setCanClone(true); setIsDelBtnClicked(true)}}  className='delete-icon-container'>
                            <i className='icon-delete' style={{color: isDelBtnClicked ? '#D5121A' : '#000000'}}></i>
                            {
                                isDelBtnClicked &&
                                <div className={`delete-tooltip ${delPosition}`}>
                                    <div className="alert-title">ALERT!!</div>
                                    <div className="alert-content"> {`Are you sure you want to delete this ${compType === 'window_frameout' ? "frameout" : "window"}?`}</div>
                                    <button className="btn btn-danger" onClick={(e) => removeComponent(const_var.doorUniqueId)}>
                                        YES DELETE
                                    </button>
                                    <i className='icon-close' onClick={(e) => {e.stopPropagation(); handleDeleteClick(false);}}></i>
                                </div>
                            }
                        </div>
                        <div onClick={(e)=> {setWarnTooltipPosition(e); setIsDelBtnClicked(false); cloneComponent(const_var.doorUniqueId, e)}} className='clone-icon-container' >
                            <i className='icon-duplicate-ico' style={{color: !canClone ? '#FF8900' : '#000000'}}></i>
                            {
                                !canClone &&
                                <div className={`warning-tooltip ${warnPosition}`}>
                                    <div className='warning-content'>This item doesn’t fit and can’t be placed on the selected wall.</div>
                                    <i className='icon-close' onClick={(e) => {e.stopPropagation(); handleSetCanClone();}}></i>
                                </div>
                            }
                        </div>                        
                    </Html>
                )}
                
                {((isDrag) || (isHovered) || (selectedCmpType === 'window' && isShowEditIconSection && const_var.doorUniqueId === id && !isDoorTransparent /* && !transparentState */)) && <WindowOutLineSection width={width} height={height} isDeleted={isDelBtnClicked} canClone={canClone} />}
                <Html className='clone-success-container' position={addedWindowPos}>
                    {
                        isSnackBar && 
                        <div >
                            <span>
                                {'Window Cloned Successfully'}
                            </span>
                            <span>
                                <i className='icon-close' style={{fontSize: '10px', marginLeft: '5px', cursor: 'pointer'}} onClick={() => setIsSnackBar(false)}></i>
                            </span>
                        </div>
                    }
                </Html>
            </group>
        </group>
    )
}

export default WindowModel